import axios from "axios";
import {
  EmailType,
  EmailFormat,
  EmailFormatFormData,
} from "../types/emailFormat.types";
import { ApiChannelFormData } from "../types/apiChannel.types";
import {
  CampaignTypeFormData,
  CreateCampaignTypeResponse,
  GetCampaignTypeResponse,
  UpdateCampaignTypeResponse,
} from "../types/campaignType.types";
import {
  GetAssignmentTypesResponse,
  CreateRoutingPriorityPayload,
  GetRoutingPrioritiesResponse,
  CreateRoutingPriorityResponse,
} from "../types/routingPriority.types";
//const BASE_URL = "https://rprocrmsasdevapi.rprocrm.com/api   http://localhost:8088/api";
//export const BASE_URL = "http://localhost:8088/api";
//export const BASE_URL = "https://rprocrmsasdevapi.rprocrm.com/api";
export const BASE_URL = "https://metropreapi.rprocrm.com/api";
//export const BASE_URL = "https://zentroapi.orimark.com/api";
// Auth check utility function
const handleAuthError = (
  status: number,
  navigate?: (path: string) => void
): boolean => {
  if (status === 401) {
    // Clear auth data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userGroupPayload");
    localStorage.removeItem("userFullName");
    localStorage.removeItem("message");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userTypeId");
    localStorage.removeItem("tenantId");
    localStorage.removeItem("groupId");
    localStorage.removeItem("activeMenuID");

    // If navigate function is provided, use it to redirect
    if (navigate) {
      navigate("/");
      return true;
    }

    // Otherwise use window.location for global redirect
    window.location.href = "/";
    return true;
  }
  return false;
};

//*******************************/
//****** handleSignIn **********/
//*****************************/
export const handleSignIn = async (
  email: string,
  password: string,
  navigate: (path: string) => void,
  setErrorMsg: (msg: string) => void
): Promise<{ userTypeID: number; message?: string }> => {
  try {
    let dataToSend = null;
    if (email.toLowerCase() === "superadmin") {
      dataToSend = {
        UserName: email,
        Password: password,
      };
    } else {
      dataToSend = {
        UserName: email, // Assuming email is being used as UserID
        Password: password,
      };
    }

    const response = await fetch(`${BASE_URL}/Login/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    });

    if (!response.ok) {
      // Check for 401 error
      if (handleAuthError(response.status, navigate)) {
        return { userTypeID: 0, message: "Authentication failed." };
      }
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    if (result.user.result != undefined) {
      const superAdminDetails = result.user.result.superAdminDetails;
      localStorage.setItem("authToken", String(result.accessToken));
      localStorage.setItem(
        "userFullName",
        String(superAdminDetails.admiN_USER_NAME)
      );
      localStorage.setItem(
        "superAdminEmail",
        String(superAdminDetails.admiN_EMAIL)
      );
      localStorage.setItem(
        "superAdminPhone",
        String(superAdminDetails.admiN_PHONE)
      );
      localStorage.setItem("superAdminId", String(superAdminDetails.admiN_ID));
      navigate("/SuperAdminDashboard");
      return {
        userTypeID: 0, // or whatever userTypeID represents super admin
        message: "Super Admin authenticated successfully",
      };
    } else {
      localStorage.setItem("authToken", String(result.accessToken));
      localStorage.setItem("userFullName", String(result.user.user.userName));
      localStorage.setItem(
        "message",
        String("User Authenticated Successfully")
      );
      localStorage.setItem("UserId", String(result.user.user.userId));
      localStorage.setItem("userTypeId", String(result.user.user.userTypeId));
      localStorage.setItem("tenantId", String(result.user.user.tenantId));
      localStorage.setItem("groupId", String(result.user.user.groupId));
      //navigate("/dashboard");
      window.location.replace(`/#/dashboard`);
      window.location.reload();
      return { userTypeID: result.userTypeID };
    }
  } catch (error) {
    console.error("Error during authentication:", error);
    setErrorMsg("Authentication failed.");
    return { userTypeID: 0, message: "Authentication failed." };
  }
};
//*****************************/
//****** handleSignIn**********/
//*****************************/

//*****************************/
//****** handleLogout**********/
//*****************************/
export const handleLogout = (navigate: (path: string) => void): void => {
  // Remove the authToken from localStorage userGroupPayload
  localStorage.removeItem("authToken");
  localStorage.removeItem("userGroupPayload");
  localStorage.removeItem("userFullName");
  localStorage.removeItem("message");
  localStorage.removeItem("UserId");
  localStorage.removeItem("userTypeId");
  localStorage.removeItem("tenantId");
  localStorage.removeItem("groupId");
  localStorage.removeItem("activeMenuID");
  // Redirect to login page
  navigate("/");
};
//*****************************/
//****** handleLogout**********/
//*****************************/

//*****************************/
//*****fetchAllowedMenus*******/
//*****************************/
export interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  displayPosition?: number;   // ← ADD THIS
  subMenuList?: [];
}

export interface MenuResponse {
  menuList: MenuItem[];
}

export const fetchAllowedMenus = async (): Promise<MenuItem[]> => {
  try {
    const userTypeID = localStorage.getItem("userTypeId") || "0";
    const tenantID = localStorage.getItem("tenantId") || "0";
    const accessToken = localStorage.getItem("authToken") || "";
    const response = await fetch(
      `${BASE_URL}/Menu/GetAllowedMenuByUserType?userTypeID=${parseInt(
        userTypeID
      )}&tenantID=${parseInt(tenantID)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: MenuResponse = await response.json();
    return data.menuList;
  } catch (error) {
    console.error("Error fetching allowed menus:", error);
    return [];
  }
};
//*****************************/
//*****fetchAllowedMenus*******/
//*****************************/

//*****************************/
//*****createUserGroup*******/
//*****************************/
interface CreateUserGroupPayload {
  groupName: string;
  isActive: boolean;
  createdBy: number;
}

interface CreateUserGroupResponse {
  isCreated: boolean;
}

export const createUserGroup = async (
  payload: CreateUserGroupPayload
): Promise<CreateUserGroupResponse> => {
  const accessToken = localStorage.getItem("authToken");
  const response = await fetch(`${BASE_URL}/UserGroup/CreateUserGroup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  // Check for 401 error
  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error("Failed to create user group");
  }

  const data: CreateUserGroupResponse = await response.json();

  if (data.isCreated) {
    localStorage.setItem("userGroupPayload", JSON.stringify(payload));
  }
  return data;
};
//*****************************/
//*****createUserGroup*******/
//*****************************/

//*******************************/
//*****fetchUserGroupData*******/
//*****************************/
export interface UserGroup {
  groupId: number;
  groupName: string;
  isActive: boolean;
  tenantId: number;
}

interface ApiResponse {
  groupList: UserGroup[];
}

export const fetchUserGroupData = async (): Promise<UserGroup[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/UserGroup/GetAllUserGroups?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    // Transform the property names to match your interface
    const transformedData: UserGroup[] = data.groupList.map((group: any) => ({
      groupId: group.groupdId,
      groupName: group.groupName,
      isActive: group.isActive,
      tenantId: group.tenantID,
    }));
    return transformedData;
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//*****fetchUserGroupData*******/
//*****************************/

//*****************************/
//*****UpdateUserGroup*******/
//*****************************/
interface UpdateUserGroupPayload {
  groupID: number;
  groupName: string;
  isActive: boolean;
  modifiedBy: number;
}

interface UpdateUserGroupResponse {
  isUpdated: boolean;
  message?: string;
}

export const UpdateUserGroup = async (
  payload: UpdateUserGroupPayload
): Promise<UpdateUserGroupResponse> => {
  console.log(payload);
  const accessToken = localStorage.getItem("authToken");
  const response = await fetch(`${BASE_URL}/UserGroup/UpdateUserGroup`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  // Check for 401 error
  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error("Failed to create user group");
  }

  const data: UpdateUserGroupResponse = await response.json();

  if (data.isUpdated) {
    localStorage.setItem("userGroupPayload", JSON.stringify(payload));
  }
  return data;
};
//*****************************/
//*****UpdateUserGroup*******/
//*****************************/

//*****************************/
//*****fetchUserData*******/
//*****************************/
export interface User {
  tenantId: number;
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  alternativePhone: string;
  reportTo: number;
  groupId: number;
  isFallbackUser: boolean;
  isActive: boolean;
  userStatusId: number;
  userTypeId: number;
  modifiedBy: number;
  reportToUserName: string;
  groupName: string;
  userTypeName: string;
  loginUserName: string;
}

interface ApiResponse {
  users: User[];
}

export const fetchUserData = async (): Promise<User[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");

    // Check if required values are available
    if (!accessToken || !tenantId || !userId) {
      throw new Error("Missing authentication or tenant/user information");
    }

    const response = await fetch(
      `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add JWT token to Authorization header
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: ApiResponse = await response.json();
    return data.users;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchUserData**********/
//*****************************/

//*****************************/
//*****fetchUserEditData*******/
//*****************************/
export interface UserEditResponse {
  users: User[];
}
export const fetchUserEditData = async (
  userId: number,
  tenantId: number
): Promise<UserEditResponse> => {
  const accessToken = localStorage.getItem("authToken");
  try {
    const response = await fetch(
      `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}&userId=${userId}`,
      {
        method: "GET",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: UserEditResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user edit data:", error);
    throw error;
  }
};
//*****************************/
//*****fetchUserEditData*******/
//*****************************/

//*******************************/
//*****createUser*******/
//*****************************/
interface CreateUserRequest {
  userName: string;
  mobile: string;
  email: string;
  alternativePhone: string;
  reportTo: number;
  passwordHash: string;
  groupId: number;
  isFallbackUser: boolean;
  requestedBy: number;
  userStatusId: number;
  userTypeId: number;
  tenantId: number;
  loginUserName: string;
}

interface CreateUserResponse {
  isCreated: boolean;
  message: string;
}

export const createUser = async (
  userData: CreateUserRequest
): Promise<CreateUserResponse> => {
  try {
    // Retrieve stored auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/User/CreateUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(userData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: CreateUserResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//*****createUser*******/
//*****************************/

//*******************************/
//*******updateUser*************/
//*****************************/
export interface UpdateUser {
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  alternativePhone: string;
  reportTo: number;
  groupId: number;
  isFallbackUser: boolean;
  isActive: boolean;
  userStatusId: number;
  userTypeId: number;
  modifiedBy: number;
  passwordHash: string;
}

export const updateUser = async (userData: UpdateUser): Promise<boolean> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      console.error("Authentication token not found");
      return false;
    }

    console.log("userData", userData);
    const response = await fetch(`${BASE_URL}/User/UpdateUser`, {
      method: "PUT", // Assuming it's a PUT request for updating
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return false;
    }

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error updating user:", errorData);
      return false;
    }

    const result = await response.json();
    console.log("User updated successfully:", result);
    return true;
  } catch (error) {
    console.error("Error in updateUser API call:", error);
    return false;
  }
};
//*******************************/
//*********updateUser***********/
//*****************************/

//*******************************/
//****fetchAccessPermissionData******/
//*****************************/
export interface accessPermissions {
  permissionId: number;
  userTypeId: number;
  menuId: number;
  isAccessAllowed: boolean;
  menuName: string;
  parentMenuName: string;
  isMenu: boolean;
  isSubMenu: boolean;
  leadName: string;
  userTypeName: string;
}

interface accessPermissionsApiResponse {
  accessPermissionsList: accessPermissions[];
}

export const fetchAccessPermissionData = async (): Promise<
  accessPermissions[]
> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/AccessPermission/GetAllAccessPermission?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as accessPermissionsApiResponse;

    return data.accessPermissionsList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//****fetchAccessPermissionData******/
//*****************************/

//*******************************/
//****createAccessPermission******/
//*****************************/
export const createAccessPermission = async (payload: any) => {
  try {
    // Get auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    const response = await fetch(
      `${BASE_URL}/AccessPermission/CreateAccessPermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return { isCreated: true, data };
  } catch (error) {
    console.error("Error creating access permission:", error);
    throw error;
  }
};
//*******************************/
//****createAccessPermission******/
//*****************************/

//*******************************/
//*******fetchStateData*********/
//*****************************/
export interface State {
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface stateApiResponse {
  stateList: State[];
}

export const fetchStateData = async (): Promise<State[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(`${BASE_URL}/Location/GetAllStates`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as stateApiResponse;
    return data.stateList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//*******fetchStateData*********/
//*****************************/

//*******************************/
//********updateState***********/
//*****************************/
export const updateState = async (payload: any) => {
  try {
    console.log("Payload for updateState:", payload);
    // Get auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    const response = await fetch(`${BASE_URL}/Location/UpdateState`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return { isUpdated: true, data };
  } catch (error) {
    console.error("Error updating access permission:", error);
    throw error;
  }
};
//*******************************/
//********updateState***********/
//*****************************/

//*******************************/
//********fetchDistrictData***********/
//*****************************/
export interface District {
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface districtApiResponse {
  districtList: District[];
}

export const fetchDistrictData = async (): Promise<District[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(`${BASE_URL}/Location/GetAllDistricts`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as districtApiResponse;
    return data.districtList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//********fetchDistrictData***********/
//*****************************/

//*******************************/
//********updateDistrict***********/
//*****************************/
export const updateDistrict = async (payload: any) => {
  try {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.put(
      `${BASE_URL}/Location/UpdateDistrict`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    // Check for 401 in axios response
    if (response.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }

    return response.data;
  } catch (error) {
    // Handle axios error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }
    throw error;
  }
};
//*******************************/
//********updateDistrict***********/
//*****************************/

//*******************************/
//********fetchCityData***********/
//*****************************/
export interface City {
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
  cityId: number;
  cityName: string;
}

interface cityApiResponse {
  cityList: City[];
}

export const fetchCityData = async (): Promise<City[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/Location/GetAllCities?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as cityApiResponse;
    return data.cityList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//********fetchCityData***********/
//*****************************/

//*******************************/
//*********createCity***********/
//*****************************/
export const createCity = async (payload: any) => {
  const authToken = localStorage.getItem("authToken");

  if (!authToken) {
    throw new Error("Authentication token not found");
  }

  const response = await axios.post(
    `${BASE_URL}/Location/CreateCity`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
//*******************************/
//*********createCity***********/
//*****************************/

//*******************************/
//********fetchAllMenus*********/
//*****************************/
export interface AllMenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList: { subMenuId: number; subMenuName: string }[];
}

export interface AllMenuResponse {
  menuList: AllMenuItem[];
}

export const fetchAllMenus = async (): Promise<AllMenuItem[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/MasterData/GetAllMenus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AllMenuResponse = await response.json();
    return data.menuList;
  } catch (error) {
    console.error("Error fetching all menus:", error);
    return [];
  }
};
//*******************************/
//*******fetchAllMenus**********/
//*****************************/

export interface userTypeItem {
  typeId: number;
  typeName: string;
  priority: string;
}

export interface AllUserTypeResponse {
  userTypeList: userTypeItem[];
}

export const fetchAllUserType = async (): Promise<userTypeItem[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/MasterData/GetAllUserTypes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AllUserTypeResponse = await response.json();
    return data.userTypeList;
  } catch (error) {
    console.error("Error fetching all menus:", error);
    return [];
  }
};

//*******************************/
//******fetchLocationData*******/
//*****************************/
export interface location {
  districtID: number;
  districtName: string;
  stateID: number;
  stateName: string;
  isActive: boolean;
  cityID: number;
  cityName: string;
  locationID: number;
  locationName: string;
  street: string;
  zipcode: number;
  locality: string;
  latitude: string;
  longitude: string;
  tenantID: number;
}

interface locationApiResponse {
  locationList: location[];
}

export const fetchLocationData = async (): Promise<location[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/Location/GetAllLocation?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as locationApiResponse;
    return data.locationList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//*******************************/
//******fetchLocationData*******/
//*****************************/

export const resetPassword = async (payload: any) => {
  try {
    const authToken = localStorage.getItem("authToken");
    console.log("Reset Password Data:", payload); // Debugging line

    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.patch(
      `${BASE_URL}/Login/Resetpassword`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    // Check for 401 in axios response
    if (response.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }

    return response.data;
  } catch (error) {
    // Handle axios error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }
    throw error;
  }
};

//*****************************/
//*****fetchProjectData*******/
//*****************************/
export interface Project {
  projectID: number;
  projectName: string;
  description: string;
  locationID: number;
  contactMails: string;
  brochure: string;
  priceQuote: string;
  tenantId: boolean;
  isActive: boolean;
  locationName: string;
}

interface projectApiResponse {
  projectList: Project[];
}

export const fetchProjectData = async (): Promise<Project[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/Project/GetAllProjects?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add JWT token to Authorization header
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: projectApiResponse = await response.json();
    return data.projectList;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchProjectData**********/
//*****************************/

//*******************************/
//********creatProject**********/
//*****************************/
interface CreateProjectRequest {
  projectName: string;
  description: string;
  locationID: number;
  isActive: boolean;
  brochure: string;
  priceQuote: string;
  createdBy: number;
  tenantId: number;
}

interface ProjectData {
  projecT_ID: number;
  projecT_NAME: string;
  description: string;
  locatioN_ID: number;
  locatioN: string | null;
  contactMails: string | null;
  brochure: string;
  priceQuote: string;
  createdBy: number;
  createdOn: string;
  modifiedBy: number | null;
  modifiedOn: string | null;
  tenanT_ID: number;
  user: string | null;
  iS_ACTIVE: boolean;
}

interface CreateProjectResponse {
  data: ProjectData;
  isCreated: boolean;
  message: string;
}

export const creatProject = async (
  projectData: CreateProjectRequest
): Promise<CreateProjectResponse> => {
  try {
    // Retrieve stored auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/Project/CreateProject`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(projectData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: CreateProjectResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//********creatProject**********/
//*****************************/

//*******************************/
//****fetchProjectEditData******/
//*****************************/
export const fetchProjectEditData = async (
  projectID: number,
  locationID: number
) => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    const response = await fetch(
      `${BASE_URL}/Project/GetProjectById?projectId=${projectID}&tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    // Debugging line
    return data;
  } catch (error) {
    console.error("Error fetching project edit data:", error);
    throw error;
  }
};
//*******************************/
//****fetchProjectEditData******/
//*****************************/

//*******************************/
//*********updateProject********/
//*****************************/
export const updateProject = async (projectData: {
  projectID: number;
  projectName: string;
  description: string;
  locationID: number;
  isActive: boolean;
  contactMails: string;
  brochure: string;
  priceQuote: string;
  tenantId: number;
  modifieddBy: number;
}) => {
  try {
    console.log("Update Project Data:", projectData);
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/Project/UpdateProject`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(projectData),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating project:", error);
    throw error;
  }
};
//*******************************/
//*********updateProject********/
//*****************************/

//*****************************/
//*****fetchProjectData*******/
//*****************************/
export interface AssignmentType {
  typeId: number;
  typeName: string;
}

export interface AssignmentTypeResponse {
  assignmentTypeList: AssignmentType[];
}

export const fetchAllAssignmentTypes = async (): Promise<AssignmentType[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/MasterData/GetAllAssignmentTypes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AssignmentTypeResponse = await response.json();
    return data.assignmentTypeList;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchProjectData**********/
//*****************************/

//*****************************/
//****assignTargetToUsers*****/
//***************************/
export interface AssignmentRequest {
  tenantId: number;
  assignmentTypeId: number;
  assignmentObjectId: number;
  isAssigned: boolean;
  listOfUsers: {
    userId: number;
  }[];
  createdBy: number;
}

export const assignTargetToUsers = async (
  assignmentData: AssignmentRequest
): Promise<any> => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${BASE_URL}/User/AssignTargetToUsers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(assignmentData),
    });

    if (!response.ok) {
      throw new Error(`Failed to assign users: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error assigning users:", error);
    throw error;
  }
};
//*****************************/
//****assignTargetToUsers*****/
//***************************/

//*****************************/
//*****fetchAllAssigUsers*******/
//*****************************/
export interface AssignUser {
  userId: number;
  userName: string;
}

export interface AssignUserResponse {
  users: AssignUser[];
}

export const fetchAllAssigUsers = async (
  assignmentTypeId: number,
  assignmentObjectId: number
): Promise<AssignUser[]> => {
  try {
    console.log("Assignment Type ID:", assignmentTypeId);
    console.log("Assignment Object ID:", assignmentObjectId);
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/UserAssignment/GetUsersAssignedToObject?AssignmentTypeId=${assignmentTypeId}&AssignmentObjectId=${assignmentObjectId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AssignUserResponse = await response.json();
    return data.users;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchAllAssigUsers*******/
//***************************/

//*****************************/
//****UpdateUserTargets*****/
//***************************/
export interface AssignmentProjectRequest {
  userId: number;
  assignmentTypeId: number;
  listOfAssignments: {
    assignmentObjectId: number;
  }[];
  isAssigned: boolean;
  tenantId: number;
  createdBy: number;
}

export const UpdateUserTargets = async (
  assignmentData: AssignmentProjectRequest
): Promise<any> => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${BASE_URL}/User/UpdateUserTargets`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(assignmentData),
    });

    if (!response.ok) {
      throw new Error(`Failed to assign users: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error assigning users:", error);
    throw error;
  }
};
//*****************************/
//****UpdateUserTargets*****/
//***************************/

//*****************************/
//*****fetchAllAssigedProject*******/
//*****************************/
export interface AssignedProject {
  assignmentId: number;
  assignmentName: string;
  assignmentObjectId: number;
}

export interface AssignedProjectResponse {
  assignments: AssignedProject[];
}

export const fetchAllAssigedProject = async (
  UserId: number,
  AssignmentTypeId: number
): Promise<AssignedProject[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/UserAssignment/GetUserAssignments?TenantId=${tenantId}&UserId=${UserId}&AssignmentTypeId=${AssignmentTypeId}&IsActive=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AssignedProjectResponse = await response.json();
    return data.assignments;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchAllAssigedProject*******/
//***************************/

//**************************************/
//*******fetchMeadiaSourceData*********/
//************************************/
export interface MeadiaSource {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}

interface meadiaSourceApiResponse {
  mediaSourceList: MeadiaSource[];
}

export const fetchMeadiaSourceData = async (): Promise<MeadiaSource[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/MediaSource/GetAllMediaSource?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = (await response.json()) as meadiaSourceApiResponse;
    return data.mediaSourceList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//**************************************/
//*******fetchMeadiaSourceData*********/
//************************************/

//**************************************/
//*******createMeadiaSource*********/
//************************************/
export const createMeadiaSource = async (payload: any) => {
  const authToken = localStorage.getItem("authToken");

  if (!authToken) {
    throw new Error("Authentication token not found");
  }

  const response = await axios.post(
    `${BASE_URL}/MediaSource/CreateMediaSource`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
//**************************************/
//*******createMeadiaSource*********/
//************************************/

//**************************************/
//*******updateMediaSource*********/
//************************************/
export const updateMediaSource = async (payload: any) => {
  try {
    // Get auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    const response = await fetch(`${BASE_URL}/MediaSource/UpdateMediaSource`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return { isUpdated: true, data };
  } catch (error) {
    console.error("Error updating access permission:", error);
    throw error;
  }
};
//**************************************/
//*******updateMediaSource*********/
//************************************/

//**************************************/
//*******GetPropertyTypes*********/
//************************************/
export const GetPropertyTypes = async (payload: any) => {
  try {
    // Get auth token from localStorage
    const accessToken = localStorage.getItem("authToken");
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    const response = await fetch(`${BASE_URL}/PropertyType/GetPropertyTypes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return { data };
  } catch (error) {
    console.error("Error updating access permission:", error);
    throw error;
  }
};
//**************************************/
//*******GetPropertyTypes*********/
//************************************/

//**************************************/
//*******updatePropertyType*********/
//************************************/
export const updatePropertyType = async (payload: any) => {
  try {
    // Get auth token from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenant_ID = localStorage.getItem("tenantId");

    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    if (!tenant_ID) {
      throw new Error("Tenant ID not found");
    }

    // Add tenantId to the payload
    const updatedPayload = {
      ...payload,
      tenant_ID,
    };

    const response = await fetch(
      `${BASE_URL}/PropertyType/UpdatePropertyType`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updatedPayload),
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return { isUpdated: true, data };
  } catch (error) {
    console.error("Error updating access permission:", error);
    throw error;
  }
};
//**************************************/
//*******updatePropertyType*********/
//************************************/

//**************************************/
//*******createMeadiaSource*********/
//************************************/
export const createPropertyType = async (payload: any) => {
  const authToken = localStorage.getItem("authToken");

  if (!authToken) {
    throw new Error("Authentication token not found");
  }

  const response = await axios.post(
    `${BASE_URL}/PropertyType/CreatePropertyType`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
//**************************************/
//*******createMeadiaSource*********/
//************************************/
//*****************************/
//*****fetchAllAssigedProject*******/
//*****************************/
export interface AssignedUsers {
  userId: number;
  userName: string;
}

export interface AssignedObjectsResponse {
  users: AssignedUsers[];
}

export const fetchAllAssigedObjects = async (
  AssignmentObjectId: number,
  AssignmentTypeId: number
): Promise<AssignedUsers[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/UserAssignment/GetUsersForAssignment?AssignmentTypeId=${AssignmentTypeId}&AssignmentObjectId=${AssignmentObjectId}&IsActive=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AssignedObjectsResponse = await response.json();
    return data.users;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchAllAssigedProject*******/
//***************************/

//**************************************/
//*******UpdateSubMediaSource*********/
//************************************/
interface UpdateSubMediaSourcePayload {
  id: number;
  name: string;
  mediaSourceID: number;
  isActive: boolean;
  modifieddBy: number;
}

interface UpdateSubMediaSourceResponse {
  isUpdated: boolean;
  message?: string;
}

export const updateSubMediaSource = async (
  payload: UpdateSubMediaSourcePayload
): Promise<UpdateSubMediaSourceResponse> => {
  try {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.put(
      `${BASE_URL}/SubMediaSource/UpdateSubMediaSource`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    // Handle axios error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }
    throw error;
  }
};
//**************************************/
//*******UpdateSubMediaSource*********/
//************************************/

//**************************************/
//*******createSubMeadiaSource*********/
//************************************/
export const createSubMeadiaSource = async (payload: any) => {
  try {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.post(
      `${BASE_URL}/SubMediaSource/CreateSubMediaSource`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (handleAuthError(response.status)) {
      return [];
    }

    return response.data;
  } catch (error) {
    // Handle axios error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }
    throw error;
  }
};
//**************************************/
//*******createSubMeadiaSource*********/
//************************************/

//**************************************/
//*******fetchSubMeadiaSourceData*********/
//************************************/
export interface SubMediaSource {
  id: number;
  name: string;
  mediaSourceID: number;
  isActive: boolean;
  createdBy: number;
  createdOn: Date;
}

interface subMediaSourceResponse {
  subMediaSourceList: SubMediaSource[];
}

export const fetchAllSubMediaSource = async (): Promise<SubMediaSource[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    if (!accessToken) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await axios.get(
      `${BASE_URL}/SubMediaSource/GetAllSubMediaSource?tenantId=${tenantId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (handleAuthError(response.status)) {
      return [];
    }

    const data = response.data as subMediaSourceResponse;
    // Filter for only active subMediaSources
    return data.subMediaSourceList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//**************************************/
//*******fetchSubMeadiaSourceData*********/
//************************************/
//*****************************/
//*****createLeadGroup*******/
//*****************************/
interface CreateLeadGroupPayload {
  groupName: string;
  groupPurpose: string;
  isActive: boolean;
  tenantId: number;
  createdBy: number;
}

interface CreateLeadGroupResponse {
  isCreated: boolean;
}

export const createLeadGroup = async (
  payload: CreateLeadGroupPayload
): Promise<CreateLeadGroupResponse> => {
  const accessToken = localStorage.getItem("authToken");
  const response = await fetch(`${BASE_URL}/LeadAction/CreateLeadGroup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  // Check for 401 error
  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error("Failed to create lead group");
  }

  const data: CreateUserGroupResponse = await response.json();

  if (data.isCreated) {
    localStorage.setItem("leadGroupPayload", JSON.stringify(payload));
  }
  return data;
};
//*****************************/
//*****createLeadGroup*******/
//*****************************/

//*****UpdateLeadGroup*******/
//*****************************/
interface UpdateLeadGroupPayload {
  groupID: number;
  groupName: string;
  groupPurpose: string;
  isActive: boolean;
  modifiedBy: number;
  tenantId: number;
}

interface UpdateLeadGroupResponse {
  isUpdated: boolean;
}

export const UpdateLeadGroup = async (
  payload: UpdateLeadGroupPayload
): Promise<UpdateLeadGroupResponse> => {
  console.log(payload);
  const accessToken = localStorage.getItem("authToken");
  const response = await fetch(`${BASE_URL}/LeadAction/UpdateLeadGroup`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  // Check for 401 error
  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error("Failed to create user group");
  }

  const data: UpdateLeadGroupResponse = await response.json();

  if (data.isUpdated) {
    localStorage.setItem("userLeadPayload", JSON.stringify(payload));
  }
  return data;
};
//*****************************/
//*****UpdateLeadGroup*******/
//*****************************/

//*******************************/
//*****fetchLeadGroupData*******/
//*****************************/
export interface LeadGroup {
  groupId: number;
  groupName: string;
  groupPurpose: string;
  isActive: boolean;
  tenantId: number;
}

interface ApiResponse {
  leadGroupList: LeadGroup[];
}

export const fetchLeadGroupData = async (): Promise<LeadGroup[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/LeadAction/GetLeadGroups?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    // Transform the property names to match your interface
    const transformedData: LeadGroup[] = data.leadGroups.map((group: any) => ({
      groupId: group.groupId,
      groupName: group.groupName,
      groupPurpose: group.groupPurpose,
      isActive: group.isActive,
      tenantId: group.tenantID,
    }));
    return transformedData;
  } catch (error) {
    console.error("Error fetching lead group data:", error);
    return [];
  }
};
//*******************************/
//*****fetchLeadGroupData*******/
//*****************************/
//*******************************/
//********creatLead**********/
//*****************************/
interface CreateLeadRequest {
  firstName: string;
  lastName: string;
  gender: string;
  dob?: string | null;
  dom?: string | null;
  mobile: string;
  email: string;
  address: string;
  stateId: number | null;
  districtId: number | null;
  cityId: number | null;
  zipCode: number | null;
  sourceId: number | null;
  subSourceId: number | null;
  currentStatus: number | null;
  incomeFrom: number | null;
  incomeTo: number | null;
  budgetMin: number | null;
  budgetMax: number | null;
  initialAssignedUser: number;
  currentAssignedUser: number;
  tenantId: number;
  createdBy: number;

  // ✅ FIXED: string to match formData and payload
  countryCode: string;
  alternateMobile: string | null;
  alternateMobileCountryCode: string;

  preferences: Array<{
    preferenceTypeID: number;
    preferenceValue: string;
    specialNotes: string;
  }>;
  followups: Array<{
    logId: null;
    projectId: number | null;
    assignedUser: number;
    followupTypeId: number;
    followupDate: string;
    taskNotes: string;
  }>;
  siteVisits: Array<{
    siteVisitDate: string;
    projectId: number;
    remark: string;
  }>;
}

interface CreateLeadResponse {
  isCreated: boolean;
  message: string;
}

export const createLead = async (
  leadData: CreateLeadRequest
): Promise<CreateLeadResponse> => {
  try {
    // Retrieve stored auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/Lead/CreateLead`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(leadData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: CreateLeadResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//********creatLead**********/
//*****************************/

//*******************************/
//********UpdateLead**********/
//*****************************/

export interface UpdateLeadRequest {
  leadId: number;
  firstName: string;
  lastName: string | null;
  gender: string | null;
  dob?: string | null; // ISO format: YYYY-MM-DD or full datetime
  dom?: string | null;
  mobile: string;
  email: string;
  address: string | null;
  stateId: number | null;
  districtId: number | null;
  cityId: number | null;
  zipCode: number | null;
  sourceId: number;
  subSourceId: number | null;
  currentStatus: number | null;
  incomeFrom: number | null;
  incomeTo: number | null;
  budgetMin?: number | null; // optional, not used in your code but in API model
  budgetMax?: number | null; // optional, not used in your code but in API model
  initialAssignedUser: number | null;
  currentAssignedUser: number | null;
  modifiedBy: number;

  countryCode: string | null;
  alternateMobile: string | null;
  alternateMobileCountryCode: string | null;
}

export const updateLead = async (updateData: UpdateLeadRequest) => {
  const accessToken = localStorage.getItem("authToken");

  if (!accessToken) {
    throw new Error("Missing authentication token");
  }

  const response = await fetch(`${BASE_URL}/Lead/UpdateLead`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(updateData),
  });

  const text = await response.text();

  if (!response.ok) {
    console.error("❌ Update Lead Failed:");
    console.error("   Status:", response.status);
    console.error("   Response:", text);
    throw new Error(`Failed to update lead [${response.status}]: ${text}`);
  }

  return text ? JSON.parse(text) : {};
};

//*******************************/
//********UpdateLead**********/
//*****************************/

//*******************************/
//********FetchLead**********/
//*****************************/

export interface Leads {
  leadId: number;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  dom: string;
  mobile: string;
  email: string;
  address: string;
  stateId: number;
  districtId: number;
  cityId: number;
  zipCode: number;
  sourceId: number;
  subSourceId: number;
  currentStatus: number;
  incomeFrom: number;
  incomeTo: number;
  initialAssignedUser: number;
  currentAssignedUser: number;
  stateName: string;
  districtName: string;
  cityName: string;
  sourceName: string;
  subSourceName: string;
  currentStatusName: string;
  budgetMin: number;
  budgetMax: number;
  initialAssignedUserName: string;
  currentAssignedUserName: string;
  createdOn: string;

  countryCode: string;
  alternateMobile: string;
  alternateMobileCountryCode: string;
}

interface FetchLeadResponse {
  leadList: Leads[];
}

export const fetchLeadData = async (): Promise<Leads[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");
    const userTypeId = localStorage.getItem("userTypeId");
    const userId = localStorage.getItem("UserId");
    const isLoginAsManager = localStorage.getItem("isLoginAsManager") === "true";

    let url;

    if (userTypeId == "1") {
      // Super admin — get all leads
      url = `${BASE_URL}/Lead/GetAllLead?tenantId=${tenantId}`;
    } else if (isLoginAsManager) {
      // ✅ Manager view — backend fetches all reporting users' leads
      url = `${BASE_URL}/Lead/GetAllLead?tenantId=${tenantId}&assignetToUserId=${userId}&isloginasmanager=true`;
    } else {
      // Normal user — own leads only
      url = `${BASE_URL}/Lead/GetAllLead?tenantId=${tenantId}&assignetToUserId=${userId}`;
    }

    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (handleAuthError(response.status)) return [];
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data: FetchLeadResponse = await response.json();
    return data.leadList;
  } catch (error) {
    console.error("Error fetching lead data:", error);
    return [];
  }
};
//*******************************/
//********fetchLead**********/
//*****************************/

//**************************************/
//********fetchLeadDataById************/
//************************************/
export const fetchLeadDataById = async (LeadId: number) => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    const response = await fetch(
      `${BASE_URL}/Lead/GetLeadById?LeadId=${LeadId}&tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    console.log("data", data);
    return data as Leads;
  } catch (error) {
    console.error("Error fetching project edit data:", error);
    throw error;
  }
};
//**************************************/
//*********fetchLeadDataById***********/
//************************************/

//**************************************/
//*******fetchAllCampaignServices*********/
//************************************/
export interface campaigns {
  campaignId: number;
  campaignName: string;
  description: string;
  fromDate: Date;
  toDate: Date;
  mediaId: number;
  mediaSourceName: string;
  subMediumId: number;
  subMediumSourceName: string;
  mediaIdentifierKey: string;
  campaignImage: string;
  isActive: boolean | string;
}

interface campaignsApiResponse {
  campaignsList: campaigns[];
}

export const fetchAllCampaignServices = async (): Promise<campaigns[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/Campaign/GetAllCampaignService?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const rawData = await response.json();
    const data = {
      campaignsList: rawData.campaigns.map((campaign: campaigns) => ({
        ...campaign,
      })),
    } as campaignsApiResponse;

    return data.campaignsList || [];
  } catch (error) {
    console.error("Error fetching user group data:", error);
    return [];
  }
};
//**************************************/
//*******fetchAllCampaignServices*********/
//************************************/

//*******************************/
//****fetchCampaignEditData******/
//*****************************/
export const fetchCampaignEditData = async (campaignId: number) => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    const response = await fetch(
      `${BASE_URL}/Campaign/GetCampaignServiceById?campaignId=${campaignId}&tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching project edit data:", error);
    throw error;
  }
};
//*******************************/
//****fetchCampaignEditData******/
//*****************************/

//**************************************/
//*******CreateCampaign*********/
//************************************/
export interface CreateCampaign {
  tenantId: number;
  campaignName: string;
  description: string;
  fromDate: Date;
  toDate: Date;
  mediaId: number;
  subMediumId: number;
  mediaIdentifierKey: string;
  campaignImage: string;
  createdBy: number;
}

interface CampaignData {
  campaigN_ID: number;
  campaigN_IMAGE: string;
  campaigN_NAME: string;
  campaigN_TYPE_ID: number;
  campaignType: string | null;
  createD_BY: number;
  createD_ON: string;
  createdByUser: string | null;
  description: string;
  froM_DATE: Date;
  iS_ACTIVE: boolean;
  mediA_ID: number;
  mediA_IDENTIFIER_KEY: string;
  mediaSource: string | null;
  modifieD_BY: number | null;
  modifieD_ON: string | null;
  modifiedByUser: string | null;
  suB_MEDIUM_ID: number;
  subMediaSource: string | null;
  tO_DATE: Date;
  tenanT_ID: number;
}

interface CreateCampaignAPIResponse {
  data: CampaignData;
  isCreated: boolean;
  message: string;
}

export const CreateCampaigns = async (
  payload: CreateCampaign
): Promise<CreateCampaignAPIResponse> => {
  const accessToken = localStorage.getItem("authToken");

  const response = await fetch(`${BASE_URL}/Campaign/CreateCampaign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  // Check for 401 error
  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error("Failed to create user group");
  }

  const data: CreateCampaignAPIResponse = await response.json();

  if (data.isCreated) {
    localStorage.setItem("userGroupPayload", JSON.stringify(payload));
  }
  return data;
};
//**************************************/
//*******CreateCampaign*********/
//************************************/

//**************************************/
//*******UpdateCampaigns*********/
//************************************/

interface UpdateCampaignPayload {
  campaignId: number;
  campaignName: string;
  description: string;
  fromDate: Date;
  toDate: Date;
  isActive: boolean;
  mediaId: number;
  subMediumId: number;
  mediaIdentifierKey: string;
  campaignImage: string;
  modifiedBy: number;
}

interface UpdateCampaignsAPIResponse {
  isUpdated: boolean;
  message?: string;
}

export const UpdateCampaigns = async (
  payload: UpdateCampaignPayload
): Promise<UpdateCampaignsAPIResponse> => {
  try {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.put(
      `${BASE_URL}/Campaign/UpdateCampaign`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    return response.data;
  } catch (error) {
    // Handle axios error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      handleAuthError(401);
      throw new Error("Authentication failed");
    }
    throw error;
  }
};

//**************************************/
//*******UpdateCampaigns*********/
//************************************/

//*****************************/
//*****fetchInCampaignProjectData*******/
//*****************************/
interface Campaigns {
  campaignId: number;
  campaignName: string;
  projectList: ProjectList[];
}

interface ProjectList {
  projectId: number;
  projectName: string;
  identifierKey: string;
}

interface CampaignApiResponse {
  campaigns: Campaigns[];
}

export const fetchInCampaignProjectData = async (): Promise<Campaigns[]> => {
  2954;
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      `${BASE_URL}/InCampaignProject/GetInCampaignDetails?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: CampaignApiResponse = await response.json();
    return data.campaigns;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchInCampaignProjectData**********/
//*****************************/

//*******************************/
//********creatInCampaignAssignerProject**********/
//*****************************/
interface InCampaignProjectRequest {
  tenantId: number;
  campaignId: number;
  projectList: {
    projectId: number;
    identifierKey: string;
  }[];
  createdBy: number;
}

interface InCampaignProjectResponse {
  isCreated: boolean;
  message: string;
}

export const creatInCampaignAssignerProject = async (
  InCampaignAssignerProjectData: InCampaignProjectRequest
): Promise<InCampaignProjectResponse> => {
  try {
    // Retrieve stored auth token from localStorage
    const accessToken = localStorage.getItem("authToken");

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(
      `${BASE_URL}/InCampaignProject/CreateInCampaignProject`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(InCampaignAssignerProjectData),
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: InCampaignProjectResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//********creatInCampaignAssignerProject**********/
//*****************************/

//*******************************/
//********deteInCampaignAssignerProject**********/
//*****************************/
interface InCampaignProjectDeleteRequest {
  tenantId: number;
  campaignId: number;
  projectList: {
    projectId: number;
  }[];
}

interface InCampaignProjectDeleteResponse {
  isUpdated: boolean;
  message: string;
}

export const deteInCampaignAssignerProject = async (
  InCampaignAssignerProjecDeletetData: InCampaignProjectDeleteRequest
): Promise<InCampaignProjectDeleteResponse> => {
  try {
    // Retrieve stored auth token from localStorage
    const accessToken = localStorage.getItem("authToken");
    console.log("Delted API:", InCampaignAssignerProjecDeletetData);

    // Check if required values are available
    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(
      `${BASE_URL}/InCampaignProject/DeleteInCampaignProject`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(InCampaignAssignerProjecDeletetData),
      }
    );

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: InCampaignProjectDeleteResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//********deteInCampaignAssignerProject**********/
//*****************************/

//*****************************/
//*****fetchGetLeadsInGroupData*******/
//*****************************/
interface Lead {
  leadId: number;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
}

interface LeadResponse {
  leads: Lead[];
}

export const fetchGetLeadsInGroupData = async (
  GroupId: number
): Promise<Lead[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(`${BASE_URL}/LeadAction/GetLeadsInGroup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        groupId: GroupId,
        tenantId: parseInt(tenantId),
      }),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: LeadResponse = await response.json();
    return data.leads;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};
//*****************************/
//*****fetchGetLeadsInGroupData**********/
//*****************************/

//*******************************/
//********creatAddLeadsToGroup**********/
//*****************************/
interface AddLeadsToGroupRequest {
  groupId: number;
  leads: { leadId: number }[];
  isAdd: boolean;
  tenantId: number;
  createdBy: number;
}

interface AddLeadsToGroupResponse {
  isUpdated: boolean;
  message: string;
}

export const creatAddLeadsToGroup = async (
  AddLeadsToGroupResponseData: AddLeadsToGroupRequest
): Promise<AddLeadsToGroupResponse> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/LeadAction/AddLeadsToGroup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(AddLeadsToGroupResponseData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: AddLeadsToGroupResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
//*******************************/
//********creatAddLeadsToGroup**********/
//*****************************/

//*******************************/
//********fetchAllLeadStatus**********/
//*****************************/

interface LeadStatus {
  statusId: number;
  statusName: string;
}

interface AllLeadStatusResponse {
  leadStatusList: LeadStatus[];
}

export const fetchAllLeadStatus = async (): Promise<AllLeadStatusResponse> => {
  try {
    const token = localStorage.getItem("authToken");

    const response = await fetch(`${BASE_URL}/MasterData/GetAllLeadStatuses`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data as AllLeadStatusResponse;
  } catch (error) {
    console.error("Error fetching project edit data:", error);
    throw error;
  }
};

//*******************************/
//********fetchAllLeadStatus**********/
//*****************************/

//*******************************/
//****UpdateLeadStatus****/
//*****************************/

export const UpdateLeadStatus = async (payload: any) => {

  try {

    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Authentication token not found");
    }

    const response = await fetch(`${BASE_URL}/Lead/UpdateLeadStatus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {

      const errorText = await response.text();
      console.error("API Error:", errorText);

      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();

  } catch (error) {

    console.error("Error updating lead status:", error);

    throw error;

  }

};

//*******************************/
//****UpdateLeadStatus******/
//*****************************/

//*******************************/
//********fetchAllGroupByLeadId**********/
//*****************************/

interface LeadGroups {
  groupId: number;
  groupName: string;
  groupPurpose: string;
}

interface AllGroupByLeadsResponse {
  groups: LeadGroups[];
}

export const fetchAllGroupByLeadId = async (
  leadId: number
): Promise<AllGroupByLeadsResponse> => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    const response = await fetch(`${BASE_URL}/LeadAction/GetGroupsByLeadId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        leadId: leadId,
        tenantId: tenantId,
      }),
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data as AllGroupByLeadsResponse;
  } catch (error) {
    console.error("Error fetching group by leadid data:", error);
    throw error;
  }
};

//*******************************/
//********fetchAllGroupByLeadId**********/
//*****************************/

//*******************************/
//********UpdateGroupsForLead**********/
//*****************************/

interface UpdateGroupsForLeadRequest {
  leadId: number;
  groups: { groupId: number }[];
  isAdd: boolean;
  tenantId: number;
  createdBy: number;
}

interface UpdateGroupsForLeadResponse {
  isUpdated: boolean;
  message: string;
}

export const UpdateGroupsForLead = async (
  UpdateGroupsForLeadRequestData: UpdateGroupsForLeadRequest
): Promise<UpdateGroupsForLeadResponse> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    if (!accessToken) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/LeadAction/UpdateGroupsForLead`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(UpdateGroupsForLeadRequestData),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: UpdateGroupsForLeadResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

//*******************************/
//********UpdateGroupsForLead**********/
//*****************************/

//*****************************/
//*****GetAllFollowUpTypes*******/
//*****************************/
export interface followupTypeList {
  id: number;
  name: string;
  isActive: boolean;
}

export interface followupTypeResponse {
  followupTypeList: followupTypeList[];
}

export const GetAllFollowUpTypes = async (): Promise<followupTypeList[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/MasterData/GetAllFollowUpTypes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: followupTypeResponse = await response.json();
    return data.followupTypeList;
  } catch (error) {
    console.error("Error fetching allowed menus:", error);
    return [];
  }
};
//*****************************/
//*****GetAllFollowUpTypes*******/
//*****************************/

//*****************************/
//*******GetLeadLog************/
//*****************************/
export interface LeadLgoList {
  logId: number;
  leadId: number;
  statusId: number;
  statusName: string;
  followupConducted: number;
  followupTypeName: string;
  logNotes: string;
  assignedUser: number;
  assignedUserName: string;
  mediaTypeId: number;
  mediaTypeName: string;
  isNextActionRequired: boolean;
  taskId: number;
  incomingSource: string | null;
  incomingSourceName: string | null;
  incomingSubsourceId: number | null;
  incomingSubsourceName: string | null;
  eventTypeId: number;
  eventTypeName: string;
  interestedProject: string | null;
  interestedProjectName: string | null;
  taskNote: string | null;
  createdOn?: string;
}

export interface leadLogResponse {
  logs: LeadLgoList[];
}

export const GetLeadLog = async (leadId?: number): Promise<LeadLgoList[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantID = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");

    console.log("leadId", leadId);

    // Base URL with always required params
    let url = `${BASE_URL}/LeadAction/GetLeadLogs?TenantId=${tenantID}&UserId=${userId}&UserTypeId=${userTypeId}`;

    // Add LeadId if present
    if (leadId != null && leadId > 0) {
      url += `&LeadId=${leadId}`;
    }

    // For non-admin users add AssignedUser
    if (userTypeId !== "1") {
      url += `&AssignedUser=${userId}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: leadLogResponse = await response.json();
    return data.logs;
  } catch (error) {
    console.error("Error fetching lead logs:", error);
    return [];
  }
};
//*****************************/
//*******GetLeadLog************/
//*****************************/

//**********************************/
//*******CreateUserTask************/
//********************************/
interface CreateUserTaskRequest {
  leadId: number;
  logId: number;
  projectId?: number;
  assignedUser: number;
  followupTypeId: number;
  followupDate: string;
  taskNotes: string;
  //reminderDate: string;
  tenantId: number;
  createdBy: number;
}
export const createUserTask = async (
  requestData: CreateUserTaskRequest
): Promise<any> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/LeadAction/CreateUserTask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log(result);
    return result;
  } catch (error) {
    console.error("Error creating user task:", error);
    throw error;
  }
};
//**********************************/
//*******CreateUserTask************/
//********************************/

//********************************/
//*******GetUserTasks************/
//******************************/
export interface UserTaskList {
  id: number;
  leadId: number;
  projectId: number;
  assignedUser: number;
  followupTypeId: number;
  followupDate: string; // ISO date string
  taskNotes: string;
  isPostponed: boolean;
  postponeReason: string | null;
  rescheduleDate: string | null;
  reminderDate: string;
  isCompleted: boolean;
  isCanceled: boolean;
  taskCompletionDate: string | null;
  createdBy: number;
  createdByName: string | null;
  createdOn: string;
  modifiedBy: number | null;
  modifiedOn: string;
  modifiedByName: string | null;
  projectName: string;
  assignedUserName: string;
  followupTypeName: string;
  leadName: string;
}

export interface userTaskLogResponse {
  tasks: UserTaskList[];
}

interface UserTaskParameters {
  tenantId: number;
  assignedUser?: number;
  leadId?: number;
}

export const GetUserTasks = async (
  leadId?: number
): Promise<UserTaskList[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantID = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    if (!accessToken || !tenantID) {
      throw new Error("Missing authentication or tenant information");
    }

    let parameters: UserTaskParameters = {
      tenantId: tenantID ? parseInt(tenantID) : 0,
    };

    if (userTypeId == "1") {
      // ✅ Super Admin → Get all tasks
      parameters = {
        tenantId: parseInt(tenantID),
      };
    } else if (isLoginAsManager) {
      // ✅ Manager View → Backend will fetch all reporting users' tasks
      parameters = {
        tenantId: parseInt(tenantID),
        assignedUser: userId ? parseInt(userId) : 0,
        isLoginAsManager: true,
      };
    } else {
      // ✅ Normal User → Only own tasks
      parameters = {
        tenantId: parseInt(tenantID),
        assignedUser: userId ? parseInt(userId) : 0,
      };
    }

    // ✅ If LeadId is provided
    if (leadId && leadId > 0) {
      parameters.leadId = leadId;
    }

    const response = await fetch(
      `${BASE_URL}/LeadAction/GetUserTasks`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters),
      }
    );

    if (handleAuthError(response.status)) return [];

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: userTaskLogResponse = await response.json();
    return data.tasks;
  } catch (error) {
    console.error("Error fetching user tasks:", error);
    return [];
  }
};

//********************************/
//*******GetUserTasks************/
//******************************/

//********************************/
//*******CompletedUserTask************/
//******************************/
export interface UserTaskList {
  id: number;
  leadId: number;
  projectId: number;
  assignedUser: number;
  followupTypeId: number;
  followupDate: string; // ISO date string
  taskNotes: string;
  isPostponed: boolean;
  postponeReason: string | null;
  rescheduleDate: string | null;
  reminderDate: string;
  isCompleted: boolean;
  isCanceled: boolean;
  taskCompletionDate: string | null;
  createdBy: number;
  createdByName: string | null;
  createdOn: string;
  modifiedBy: number | null;
  modifiedOn: string;
  modifiedByName: string | null;
  projectName: string;
  assignedUserName: string;
  followupTypeName: string;
  leadName: string;
}

export interface userTaskLogResponse {
  tasks: UserTaskList[];
}

interface UserTaskParameters {
  tenantId: number;
  assignedUser?: number;
  leadId?: number;
  isCompleted?: boolean;
  isLoginAsManager?: boolean;
}

export const CompletedUserTask = async (
  leadId?: number
): Promise<UserTaskList[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantID = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    if (!accessToken || !tenantID) {
      throw new Error("Missing authentication or tenant information");
    }

    let parameters: UserTaskParameters;

    if (userTypeId === "1") {
      // ✅ Super Admin → All completed tasks
      parameters = {
        tenantId: parseInt(tenantID),
        isCompleted: true,
      };
    } else if (isLoginAsManager) {
      // ✅ Manager → Team completed tasks
      parameters = {
        tenantId: parseInt(tenantID),
        assignedUser: userId ? parseInt(userId) : 0,
        isCompleted: true,
        isLoginAsManager: true,
      };
    } else {
      // ✅ Normal User → Own completed tasks
      parameters = {
        tenantId: parseInt(tenantID),
        assignedUser: userId ? parseInt(userId) : 0,
        isCompleted: true,
      };
    }

    // ✅ If leadId is passed, include it
    if (leadId && leadId > 0) {
      parameters.leadId = leadId;
    }

    const response = await fetch(`${BASE_URL}/LeadAction/GetUserTasks`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(parameters),
    });

    if (handleAuthError(response.status)) return [];

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: userTaskLogResponse = await response.json();
    return data.tasks;
  } catch (error) {
    console.error("Error fetching completed user tasks:", error);
    return [];
  }
};

//********************************/
//*******CompletedUserTask************/
//******************************/

//********************************/
//*******GetUserTasksByLeadId************/
//******************************/
export const GetUserTasksByLeadId = async (
  leadId: number
): Promise<UserTaskList[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantID = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");
    let parameters: UserTaskParameters;
    if (userTypeId == "1") {
      parameters = {
        tenantId: tenantID ? parseInt(tenantID) : 0,
        leadId: leadId,
      };
    } else {
      parameters = {
        tenantId: tenantID ? parseInt(tenantID) : 0,
        leadId: leadId,
      };
    }

    const response = await fetch(`${BASE_URL}/LeadAction/GetUserTasks`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(parameters),
    });

    // Check for 401 error
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: userTaskLogResponse = await response.json();
    return data.tasks;
  } catch (error) {
    console.error("Error fetching allowed menus:", error);
    return [];
  }
};
//********************************/
//*******GetUserTasksByLeadId************/
//******************************/

//*******************************/
//********Save Preference**********/
//*****************************/

export interface PreferenceItem {
  id: number;
  preferenceName: string;
  preferenceDataJson: string;
}

export interface PreferenceResponse {
  preferenceList: PreferenceItem[];
}

export const getAllPreferenceTypes = async (): Promise<PreferenceItem[]> => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    if (!token || !tenantId) {
      throw new Error("Missing auth token or tenant ID");
    }

    const response = await fetch(
      `${BASE_URL}/MasterData/GetAllPreferenceTypes?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data: PreferenceResponse = await response.json();
    return data.preferenceList;
  } catch (error) {
    console.error("Error fetching preference types:", error);
    throw error;
  }
};

// Define interface for preference item
export interface PreferenceItemPayload {
  preferenceTypeID: number;
  preferenceValue: string;
  specialNotes: string;
}

// Define interface for full payload
export interface PreferencePayload {
  tenantId: number;
  leadID: number;
  createdBy: number;
  createdOn: string;
  preferences: PreferenceItemPayload[];
}
interface UpdatePreferenceResponse {
  isCreated: boolean;
  message: string;
}

export const savePreference = async (
  payload: PreferencePayload
): Promise<UpdatePreferenceResponse> => {
  try {
    const token = localStorage.getItem("authToken"); // Adjust token source if needed
    const response = await fetch(
      `${BASE_URL}/LeadAction/CreateLeadPreference`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },

        body: JSON.stringify(payload),
      }
    );

    // if (!response.ok) {
    //   throw new Error(`Failed to save preferences: ${response.status}`);
    // }

    const result: UpdatePreferenceResponse = await response.json();
    return result;
  } catch (error) {
    console.error("Error saving preferences:", error);
    throw error;
  }
};

//***********************************************/
//********Get All Preference By LeadId **********/
//*********************************************/

//***********************************************/
//********This API Chnages By Himansu**********/
//*********************************************/
// At the top or with your interfaces
export interface FetchedPreferenceItem {
  preferenceID: number;
  leadID: number;
  leadName: string;
  preferenceTypeID: number;
  preferenceTypeName: string;
  preferenceValue: string;
  specialNotes: string;
  tenantID: number;
  createdBy: number;
  createdByName: string;
  createdOn: string;
  modifiedBy: number;
  modifiedByName: string;
  modifiedOn: string;
}

interface PreferenceListResponse {
  preferences: FetchedPreferenceItem[];
}

// API function to get preferences by lead ID
export const getPreferencesByLeadId = async (
  leadID: number
): Promise<FetchedPreferenceItem[]> => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = Number(localStorage.getItem("tenantId"));

    const response = await fetch(`${BASE_URL}/LeadAction/GetLeadPreferences`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        leadId: leadID,
        tenantId: tenantId,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch preferences: ${response.status}`);
    }

    const result: PreferenceListResponse = await response.json();
    return result.preferences;
  } catch (error) {
    console.error("Error fetching lead preferences:", error);
    throw error;
  }
};

// Fetch all email types
export const fetchAllEmailTypes = async (): Promise<EmailType[]> => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Missing authentication information");
    }
    const response = await fetch(`${BASE_URL}/MasterData/GetAllEmailTypes`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.emailTypes.map((type: any) => ({
      id: type.id,
      typeName: type.typE_NAME,
      parameters: type.parameters,
    }));
  } catch (error) {
    console.error("Error fetching email types:", error);
    throw error;
  }
};

// Create email format
export const createEmailFormat = async (
  data: EmailFormatFormData & { tenantId: number; createdBy: number }
): Promise<boolean> => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/EmailFormat/CreateEmailFormat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...data,
        createdOn: new Date().toISOString(),
        // data already contains:
        // typeId, subject, format, attachment,
        // isExcludeBuilderEmail, isExcludeLeadEmail, isExcludeUserEmail,
        // tenantId, createdBy
      }),
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Error creating email format:", error);
    throw error;
  }
};

// Update email format
export const updateEmailFormat = async (
  data: EmailFormatFormData & {
    id: number;
    tenantId: number;
    modifiedBy: number;
  }
): Promise<boolean> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("Missing authentication information");
    }

    const response = await fetch(`${BASE_URL}/EmailFormat/UpdateEmailFormat`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...data,
        modifiedOn: new Date().toISOString(),
        // includes isExclude* flags
      }),
    });

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Error updating email format:", error);
    throw error;
  }
};

// Get email formats
export const fetchEmailFormats = async (
  typeId?: number,
  id?: number
): Promise<EmailFormat[]> => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = Number(localStorage.getItem("tenantId"));
    if (!token || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }
    const params = new URLSearchParams({ TenantId: tenantId.toString() });
    if (typeId !== undefined) params.append("TypeId", typeId.toString());
    if (id !== undefined) params.append("Id", id.toString());

    const response = await fetch(
      `${BASE_URL}/EmailFormat/GetEmailFormats?${params}`,
      {
        method: "GET",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const types = await fetchAllEmailTypes();

    return data.emailFormats.map((format: any) => ({
      id: format.id,
      typeId: format.typeId,
      typeName:
        types.find((type) => type.id === format.typeId)?.typeName || "Unknown",
      subject: format.subject,
      format: format.format,
      attachment: format.attachment, // Base64 string
      tenantId: format.tenantId,
      parameters:
        types.find((type) => type.id === format.typeId)?.parameters || "[]",

      // 🔹 Map new fields (handle null as false)
      isExcludeBuilderEmail: !!format.isExcludeBuilderEmail,
      isExcludeLeadEmail: !!format.isExcludeLeadEmail,
      isExcludeUserEmail: !!format.isExcludeUserEmail,
    }));
  } catch (error) {
    console.error("Error fetching email formats:", error);
    throw error;
  }
};

export const fetchApiChannels = async () => {
  const token = localStorage.getItem("authToken");
  const tenantId = Number(localStorage.getItem("tenantId"));
  if (!token || !tenantId) {
    throw new Error("Missing authentication or tenant information");
  }
  const response = await fetch(
    `${BASE_URL}/ApiChannel/GetApiChannels?TenantId=${tenantId}`,
    {
      headers: { Authorization: `Bearer ${token}`, accept: "/" },
    }
  );
  return response.json();
};

export const createApiChannel = async (data: ApiChannelFormData) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Missing authentication information");
  }
  const response = await fetch(`${BASE_URL}/ApiChannel/CreateApiChannel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return response.ok;
};

export const updateApiChannel = async (data: ApiChannelFormData) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Missing authentication  information");
  }
  const response = await fetch(`${BASE_URL}/ApiChannel/UpdateApiChannel`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return response.ok;
};

export const fetchApiTypes = async (): Promise<
  { id: number; typeName: string }[]
> => {
  const token = localStorage.getItem("authToken");
  const tenantId = Number(localStorage.getItem("tenantId"));
  if (!token || !tenantId) {
    throw new Error("Missing authentication or tenant information");
  }

  const response = await fetch(`${BASE_URL}/MasterData/GetAllApiTypes`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch API types");
  }

  const data = await response.json();
  console.log("sdsdsdsdsdsds", data);
  // The API returns data in the format: { apiTypes: [...] }
  if (!data.apiTypes || !Array.isArray(data.apiTypes)) {
    throw new Error("Invalid API response format");
  }

  return data.apiTypes.map((item: any) => ({
    id: item.id,
    typeName: item.name, // Map 'name' from API to 'typeName' for consistency
  }));
};

export const fetchCampaignTypes = async () => {
  const token = localStorage.getItem("authToken");
  const tenantId = Number(localStorage.getItem("tenantId"));
  if (!token || !tenantId) {
    throw new Error("Missing authentication or tenant information");
  }
  const response = await fetch(
    `${BASE_URL}/Campaign/GetAllCampaignTypeService?TenantId=${tenantId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "*/*",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch campaign types");
  }

  return response.json();
};

export const createCampaignType = async (
  data: any
): Promise<CreateCampaignTypeResponse | null> => {
  const token = localStorage.getItem("authToken") || "";
  if (!token) {
    throw new Error("Missing authentication information");
  }

  const tenantId = Number(localStorage.getItem("tenantId"));
  const requestData = {
    ...data,
    tenantId,
  };

  try {
    const response = await fetch(`${BASE_URL}/Campaign/CreateCampaignType`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result: CreateCampaignTypeResponse = await response.json();
    return result;
  } catch (error) {
    console.error("Error creating campaign type:", error);
    throw error;
  }
};
export const updateCampaignType = async (
  data: CampaignTypeFormData
): Promise<UpdateCampaignTypeResponse | null> => {
  try {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("UserId");
    const tenantId = localStorage.getItem("tenantId");

    if (!token || !userId || !tenantId) {
      throw new Error("Missing authentication or user information");
    }

    if (!data.id || data.id <= 0) throw new Error("Invalid campaign type ID");

    const response = await fetch(
      `${BASE_URL}/Campaign/UpdateCampaignTypeService`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: data.id,
          name: data.name,
          isactive: data.isactive,
          modifieD_BY: userId,
          modifieD_ON: new Date().toISOString(),
          tenantId: tenantId,
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch {
        throw new Error(
          errorText ||
          `HTTP error! status: ${response.status} - Campaign type update failed`
        );
      }
      if (errorData.message?.includes("already exists")) {
        throw new Error("Campaign type name already exists");
      }
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`
      );
    }

    const text = await response.text();
    if (!text) {
      throw new Error("Empty response from server");
    }

    let result: UpdateCampaignTypeResponse;
    try {
      result = JSON.parse(text);
    } catch (parseError) {
      console.error(
        "JSON parse error in updateCampaignType:",
        parseError,
        "Response text:",
        text
      );
      throw new Error("Invalid JSON response from server");
    }

    return result;
  } catch (error: any) {
    console.error("Error updating campaign type:", error);
    throw new Error(error.message || "Failed to update campaign type");
  }
};
export const getCampaignTypeById = async (
  id: number
): Promise<GetCampaignTypeResponse | null> => {
  try {
    const token = localStorage.getItem("authToken");
    const tenantId = Number(localStorage.getItem("tenantId"));

    if (!token) {
      throw new Error("Missing authentication information");
    }
    const response = await fetch(
      `${BASE_URL}/Campaign/GetCampaignTypeServiceById?tenantId=${tenantId}&id=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`
      );
    }

    const result: GetCampaignTypeResponse = await response.json();
    console.log("rssss", result);
    return result;
  } catch (error: any) {
    console.error("Error fetching campaign type by ID:", error);
    throw new Error(error.message || "Failed to fetch campaign type");
  }
};
export const getAllAssignmentTypes =
  async (): Promise<GetAssignmentTypesResponse> => {
    const accessToken = localStorage.getItem("authToken");
    const response = await fetch(
      `${BASE_URL}/MasterData/GetAllAssignmentTypes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (handleAuthError(response.status)) {
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(
        `Failed to fetch assignment types: ${response.statusText}`
      );
    }

    return await response.json();
  };

export const createRoutingPriority = async (
  payload: CreateRoutingPriorityPayload
): Promise<CreateRoutingPriorityResponse> => {
  const accessToken = localStorage.getItem("authToken");
  const response = await fetch(
    `${BASE_URL}/RoutingPriority/CreateRoutingPriorityService`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  if (handleAuthError(response.status)) {
    throw new Error("Authentication failed");
  }

  if (!response.ok) {
    throw new Error(
      `Failed to save routing priorities: ${response.statusText}`
    );
  }

  const data: CreateRoutingPriorityResponse = await response.json();

  if (data.isCreated) {
    localStorage.setItem("routingPriorityPayload", JSON.stringify(payload));
  }

  return data;
};

export const getRoutingPriorities =
  async (): Promise<GetRoutingPrioritiesResponse> => {
    try {
      const tenantId = localStorage.getItem("tenantId");
      const accessToken = localStorage.getItem("authToken"); // Replace with your actual token key name

      if (!tenantId) throw new Error("Tenant ID not found in localStorage");
      if (!accessToken)
        throw new Error("Access token not found in localStorage");

      const response = await axios.get<GetRoutingPrioritiesResponse>(
        `${BASE_URL}/RoutingPriority/GetAllRoutingPrirotyService?tenantId=${tenantId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching routing priorities:", error);
      throw error;
    }
  };
//***********************************************/
//********This API Chnages By Himansu**********/
//*********************************************/

//***********************************************/
//********Lead Dynamic Data**********/
//*********************************************/
export interface IntrestedProject {
  projectName: string;
  projectId: number | null;
  createdOn: string;
}

export interface LeadDynamicData {
  createdOn: string;
  leadAge: number;
  followUpAt: string;
  followUpName: string;
  initialAssignUser: number;
  currentAssignUser: number;
  initialUserName: string;
  currentUserName: string;
  projectNames: string;
  errorMessage: string;
  intrestedProjects: IntrestedProject[];
}

export const GetLeadDynamicData = async (
  leadId: number
): Promise<LeadDynamicData> => {
  const token = localStorage.getItem("authToken");
  const tenantId = localStorage.getItem("tenantId");

  if (!leadId || !tenantId) {
    throw new Error("Missing leadId or tenantId");
  }

  const payload = {
    leadId: leadId,
    tenantId: parseInt(tenantId),
  };

  const response = await fetch(`${BASE_URL}/LeadAction/GetLeadDynamicData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("API error response:", text); // ⬅️ helps you debug further
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data: LeadDynamicData = await response.json();
  return data;
};

//***********************************************/
//********Lead Dynamic Data**********/
//*********************************************/

//***********************************************/
//********Get Followup Count By Id**********/
//*********************************************/
export interface FollowUpTypeCount {
  followUpTypeId: number;
  followUpTypeName: string;
  count: number;
}

export interface FollowUpCountResponse {
  followUpTypeCounts: FollowUpTypeCount[];
}

export const GetFollowUpCountByLeadId = async (
  leadId: number
): Promise<FollowUpCountResponse> => {
  const token = localStorage.getItem("authToken");
  const tenantId = localStorage.getItem("tenantId");
  console.log(leadId);
  if (!leadId || !tenantId) {
    throw new Error("Missing leadId or tenantId");
  }

  const url = `${BASE_URL}/LeadAction/GetFollowupCountById?leadId=${leadId}&tenantId=${tenantId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("API error response:", text);
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data: FollowUpCountResponse = await response.json();
  console.log(data);
  return data;
};

//***********************************************/
//********Get Followup Count By Id**********/
//*********************************************/

//***********************************************/
//************Subscription Plan ****************/
//*********************************************/
export interface Plan {
  planId: number;
  description: string;
  amount: number;
  allowedNoOfUser: number;
  allowedNoOfLeads: number;
  allowedSms: number;
  allowedNoOfEmail: number;
  createdBy: number;
  createdOn: string;
  validity: number;
  modifiedBy: number;
  modifiedOn: string;
}

export interface PlanListResponse {
  planList: Plan[];
}

export interface CreatePlanRequest {
  description: string;
  amount: number;
  allowedNoOfUser: number;
  allowedNoOfLeads: number;
  allowedSms: number;
  allowedNoOfEmail: number;
  createdBy: number;
  validity: number;
  modifiedBy: number;
  modifiedOn: string;
  createdOn: string;
}

export interface UpdatePlanRequest {
  planId: number;
  description: string;
  amount: number;
  allowedNoOfUser: number;
  allowedNoOfLeads: number;
  allowedSms: number;
  allowedNoOfEmail: number;
  validity: number;
  modifiedBy: number;
  modifiedOn: string;
}

// Get all plans
export const GetAllPlans = async (): Promise<Plan[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(`${BASE_URL}/SuperAdmin/GetAllPlan`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: PlanListResponse = await response.json();
    return data.planList;
  } catch (error) {
    console.error("Error fetching plans:", error);
    return [];
  }
};

// Get plan by ID
export const GetPlanById = async (planId: number): Promise<Plan | null> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(
      `${BASE_URL}/SuperAdminGet/PlanById?planId=${planId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: PlanListResponse = await response.json();
    return data.planList[0] || null;
  } catch (error) {
    console.error("Error fetching plan by ID:", error);
    return null;
  }
};

// Create plan
export const CreatePlan = async (
  requestData: CreatePlanRequest
): Promise<any> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    console.log("plan create requestData", requestData);

    const response = await fetch(`${BASE_URL}/SuperAdmin/CreatePlan`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error creating plan:", error);
    throw error;
  }
};

// Update plan
export const UpdatePlan = async (
  requestData: UpdatePlanRequest
): Promise<any> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(`${BASE_URL}/SuperAdmin/UpdatePlan`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error updating plan:", error);
    throw error;
  }
};
//***********************************************/
//************Subscription Plan ****************/
//*********************************************/

//***********************************************/
//************Tenant Master*********************/
//*********************************************/
export interface Tenant {
  tenanT_ID: number;
  tenanT_NAME: string;
  tenanT_ABREVATION: string;
  addresS1: string;
  addresS2: string | null;
  website: string | null;
  phone: string | null;
  email: string | null;
  isactive: boolean;
  databasE_CONNECTION: string | null;
  createD_BY?: number;
  createD_ON: string;
  modifieD_BY?: number;
  modifieD_ON: string | null;
  isUseOwnEmail: boolean;
  isUseOwnWp: boolean;
  isUseOwnSMS: boolean;
}

export interface TenantListResponse {
  tenantsEntities: Tenant[];
}

export interface CreateTenantRequest {
  tenanT_ID?: number;
  tenanT_NAME: string;
  tenanT_ABREVATION: string;
  addresS1: string;
  addresS2: string;
  phone: string;
  email: string;
  website: string;
  isactive: boolean;
  databasE_CONNECTION: string;
  createD_BY: number;
  createD_ON: string;
  isUseOwnEmail: boolean;
  isUseOwnWp: boolean;
  isUseOwnSMS: boolean;
}

export interface UpdateTenantRequest {
  tenanT_ID: number;
  tenanT_NAME: string;
  tenanT_ABREVATION: string;
  address1: string;
  addresS2: string;
  phone: string;
  email: string;
  website: string;
  databasE_CONNECTION: string;
  isactive: boolean;
  modifieD_BY: number;
  modifieD_ON: string;
  isUseOwnEmail: boolean;
  isUseOwnWp: boolean;
  isUseOwnSMS: boolean;
}

// Get all tenants
export const GetAllTenants = async (): Promise<Tenant[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(`${BASE_URL}/SuperAdmin/GetAllTenants`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: TenantListResponse = await response.json();
    console.log("tenant data response", data);

    return data.tenantsEntities;
  } catch (error) {
    console.error("Error fetching tenants:", error);
    return [];
  }
};

// Get tenant by ID
export const GetTenantById = async (
  tenantId: number
): Promise<Tenant | null> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(
      `${BASE_URL}/SuperAdmin/GetTenantsById?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: TenantListResponse = await response.json();
    return data.tenantsEntities[0] || null;
  } catch (error) {
    console.error("Error fetching tenant by ID:", error);
    return null;
  }
};

// Create tenant
export const CreateTenant = async (
  requestData: CreateTenantRequest
): Promise<any> => {
  try {
    const accessToken = localStorage.getItem("authToken");
    console.log("tenant create requestData", requestData);

    const response = await fetch(`${BASE_URL}/SuperAdmin/CreateTenants`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error creating tenant:", error);
    throw error;
  }
};

// Update tenant
export const UpdateTenant = async (
  requestData: UpdateTenantRequest
): Promise<any> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(`${BASE_URL}/SuperAdmin/UpdateTenants`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error updating tenant:", error);
    throw error;
  }
};
//***********************************************/
//************Tenant Master*********************/
//*********************************************/

//***********************************************/
//************Stage Analysis Report*************/
//*********************************************/
export const StageAnalysisReport = async () => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId") || "0";
    const userTypeID = localStorage.getItem("userTypeId") || "0";
    const userId = localStorage.getItem("UserId") || "0";

    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();
    queryParams.append("TenantId", tenantId);
    queryParams.append("UserTypeID", userTypeID);
    queryParams.append("UserId", userId);
    queryParams.append("GetUserDetailsByTenant", "true");

    // If not admin, pass UserId
    if (userTypeID !== "1") {
      queryParams.append("UserId", userId);
    }

    // ✅ Send manager login flag
    if (isLoginAsManager) {
      queryParams.append("IsLoginAsManager", "true");
    }

    const url = `${BASE_URL}/UserReport/GetUserDetails?${queryParams.toString()}`;

    console.log("Stage Analysis URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching Stage Analysis Report:", error);
    return [];
  }
};


interface StatusCounts {
  [key: string]: number;
}

interface UserSummary {
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  loginUserName: string | null;
  tenantId: number;
  statusCounts: StatusCounts;
  total: number;
}

// Add this to your APIService file
export const FilterStageAsync = async (filterParams: {
  tenantId: number;
  fromDate?: string;
  toDate?: string;
  userId?: number;       // selected from dropdown in ReportView
  sourceId?: number;
  subSourceId?: number;
  inquireId?: number;
}) => {
  try {
    const accessToken      = localStorage.getItem("authToken");
    const loggedUserId     = Number(localStorage.getItem("UserId")     || "0");
    const userTypeId       = Number(localStorage.getItem("userTypeId") || "0");
    const isLoginAsManager = localStorage.getItem("isLoginAsManager") === "true";

    const ADMIN_USER_TYPE_ID = 1;

    const queryParams = new URLSearchParams();

    // ── Required ──────────────────────────────────────────────────────────────
    queryParams.append("tenantId",   filterParams.tenantId.toString());
    queryParams.append("userTypeId", userTypeId.toString());

    // ── Manager flag ──────────────────────────────────────────────────────────
    if (isLoginAsManager) {
      queryParams.append("isLoginAsManager", "true");
    }

    // ── UserId priority ───────────────────────────────────────────────────────
    // Case 1: A specific user was picked from the dropdown → send that userId
    //         (works for Admin, Manager, and any role that can see others)
    // Case 2: No dropdown selection + non-admin → send logged-in userId
    //         so the controller scopes results to only that user
    // Case 3: Admin with no dropdown selection → omit userId (admin sees all)
    if (filterParams.userId && filterParams.userId > 0) {
      queryParams.append("userId", filterParams.userId.toString());
    } else if (userTypeId !== ADMIN_USER_TYPE_ID && loggedUserId > 0) {
      queryParams.append("userId", loggedUserId.toString());
    }

    // ── Optional filters ──────────────────────────────────────────────────────
    if (filterParams.fromDate)    queryParams.append("fromDate",    filterParams.fromDate);
    if (filterParams.toDate)      queryParams.append("toDate",      filterParams.toDate);
    if (filterParams.sourceId)    queryParams.append("sourceId",    filterParams.sourceId.toString());
    if (filterParams.subSourceId) queryParams.append("subSourceId", filterParams.subSourceId.toString());
    if (filterParams.inquireId)   queryParams.append("inquireId",   filterParams.inquireId.toString());

    const url = `${BASE_URL}/UserReport/GetUserDetails?${queryParams.toString()}`;

    console.log("FilterStageAsync URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    console.log("Filter API Response:", data);

    return data;

  } catch (error) {
    console.error("Error filtering stage analysis report:", error);
    throw error;
  }
};
// Add this interface at the top with your other interfaces
interface LeadDetails {
  leadId: number;
  firstName: string;
  lastName: string | null;
  gender: string | null;
  dob: string | null;
  dom: string | null;
  mobile: string;
  email: string;
  address: string | null;
  stateId: number | null;
  stateName: string | null;
  districtId: number | null;
  districtName: string | null;
  cityId: number | null;
  cityName: string | null;
  zipCode: string | null;
  sourceId: number;
  sourceName: string | null;
  subSourceId: number;
  subSourceName: string | null;
  currentStatus: number;
  currentStatusName: string | null;
  incomeFrom: number | null;
  incomeTo: number | null;
  budgetMin: number | null;
  budgetMax: number | null;
  initialAssignedUser: number;
  initialAssignedUserName: string | null;
  currentAssignedUser: number;
  currentAssignedUserName: string | null;
}

// Add this function after FilterStageAsync
export const GetUserDetailsByCount = async (params: {
  userId: number;
  tenantId: number;
  countid: number;
}): Promise<LeadDetails[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    // Build query parameters
    const queryParams = new URLSearchParams();
    queryParams.append("UserId", params.userId.toString());
    queryParams.append("TenantId", params.tenantId.toString());
    queryParams.append("CountId", params.countid.toString());
    queryParams.append("GetUserDetailsByCount", "true");
    console.log(
      "Fetching lead details from URL:",
      `${BASE_URL}/UserReport/GetUserDetails?${queryParams.toString()}`
    );

    const response = await fetch(
      `${BASE_URL}/UserReport/GetUserDetails?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Lead details response data:", data);
    // Return the leadList array from the response
    return data.leadList || [];
  } catch (error) {
    console.error("Error fetching user details by count:", error);
    throw error;
  }
};
//***********************************************/
//************Stage Analysis Report*************/
//*********************************************/

//***********************************************/
//**************Lead Lost Report****************/
//*********************************************/
interface UserLeadLostSummary {
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  loginUserName: string | null;
  tenantId: number;
  leadLostCount: number;
  leadIds?: number[]; // added to store lead IDs
}
// Get User Details For Lead Lost
export const GetUserDetailsForLeadLost = async (tenantId: string) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();
    queryParams.append("TenantId", tenantId);
    queryParams.append("UserId", userId || "0");
    queryParams.append("UserTypeId", userTypeId || "0");
    queryParams.append("GetUserDetailsForLeadLost", "true");

    // ✅ Send manager login flag
    if (isLoginAsManager) {
      queryParams.append("IsLoginAsManager", "true");
    }

    const url = `${BASE_URL}/UserReport/LeadLost?${queryParams.toString()}`;

    console.log("Lead Lost Report URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    const userLeadLostSummaries: UserLeadLostSummary[] =
      (data.userLeadLostSummaries || []).map((user: any) => ({
        userId: user.userId,
        userName: user.userName,
        mobile: user.mobile,
        email: user.email,
        loginUserName: user.loginUserName || null,
        tenantId: user.tenantId,
        leadLostCount: user.leadLostCount || 0,
        leadIds: user.leadIds || [],
      }));

    console.log("User Lead Lost Summaries:", userLeadLostSummaries);

    return userLeadLostSummaries;
  } catch (error) {
    console.error("Error fetching lead lost details:", error);
    throw error;
  }
};

// Get Lead Lost Details By Lost Count
export const GetLeadLostDetailsByLostCount = async (params: {
  leadIds: number[];
  tenantId: number;
}) => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const leadIdsQuery = params.leadIds
      .map((id) => `LeadIds=${id}`)
      .join("&");

    const response = await fetch(
      `${BASE_URL}/UserReport/LeadLost?${leadIdsQuery}&TenantId=${params.tenantId}&GetLeadLostDetailsByLostCount=true`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data.leadList) ? data.leadList : [];
  } catch (error) {
    console.error("Error fetching lead lost details:", error);
    return [];
  }
};

// Filter Lead Lost Async
export const FilterLeadLostAsync = async (filterParams: {
  tenantId: string | number;
  fromDate?: string;
  toDate?: string;
  userId?: number;
  sourceId?: number;
  subSourceId?: number;
  inquireId?: number;
}) => {
  try {
    const accessToken = localStorage.getItem("authToken");

    // ✅ Login User Details
    const loginUserId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");

    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    // ✅ Build Query Params
    const queryParams = new URLSearchParams();

    queryParams.append(
      "TenantId",
      filterParams.tenantId.toString()
    );

    queryParams.append(
      "UserId",
      loginUserId || "0"
    );

    queryParams.append(
      "UserTypeId",
      userTypeId || "0"
    );

    // ✅ Manager Login Flag
    if (isLoginAsManager) {
      queryParams.append(
        "IsLoginAsManager",
        "true"
      );
    }

    // ✅ Date Filters
    if (filterParams.fromDate) {
      queryParams.append(
        "FromDate",
        filterParams.fromDate
      );
    }

    if (filterParams.toDate) {
      queryParams.append(
        "ToDate",
        filterParams.toDate
      );
    }

    // ✅ Optional Filters
    if (filterParams.userId) {
      queryParams.append(
        "FilterUserId",
        filterParams.userId.toString()
      );
    }

    if (filterParams.sourceId) {
      queryParams.append(
        "SourceId",
        filterParams.sourceId.toString()
      );
    }

    if (filterParams.subSourceId) {
      queryParams.append(
        "SubSourceId",
        filterParams.subSourceId.toString()
      );
    }

    if (filterParams.inquireId) {
      queryParams.append(
        "InquireId",
        filterParams.inquireId.toString()
      );
    }

    queryParams.append(
      "FilterLeadLost",
      "true"
    );

    // ✅ Final URL
    const url = `${BASE_URL}/UserReport/LeadLost?${queryParams.toString()}`;

    console.log("Filter Lead Lost URL:", url);

    // ✅ API Call
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    // ✅ Parse Response
    const userLeadLostSummaries: UserLeadLostSummary[] =
      (data.userLeadLostSummaries || data.data || []).map(
        (user: any) => ({
          userId: user.userId,
          userName: user.userName,
          mobile: user.mobile,
          email: user.email,
          loginUserName: user.loginUserName || null,
          tenantId: user.tenantId,
          leadLostCount: user.leadLostCount || 0,
          leadIds: user.leadIds || [],
        })
      );

    console.log(
      "Filtered Lead Lost Result:",
      userLeadLostSummaries
    );

    return userLeadLostSummaries;
  } catch (error) {
    console.error("Error filtering lead lost:", error);
    throw error;
  }
};


//***********************************************/
//**************Lead Lost Report****************/
//*********************************************/
interface UserSiteVisitedSummary {
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  loginUserName: string | null;
  tenantId: number;
  completedTaskCount: number;
}

// Get Follow Up Details By Tenant ID (Site Visited Report)
export const GetFollowUpDetailsByTenateId = async (tenantId: string) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const userId = localStorage.getItem("UserId");
    const userTypeId = localStorage.getItem("userTypeId");
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();
    queryParams.append("tenateId", tenantId);
    queryParams.append("userId", userId || "0");
    queryParams.append("userTypeId", userTypeId || "0");

    // ✅ Send manager login flag
    if (isLoginAsManager) {
      queryParams.append("isLoginAsManager", "true");
    }

    const url = `${BASE_URL}/UserReport/GetFollowUpDetailsByTenateId?${queryParams.toString()}`;

    console.log("FollowUp Report URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    const followUpSummaries: UserSiteVisitedSummary[] =
      data.followUpSummaries || data.data || data;

    console.log("Follow Up Summaries:", followUpSummaries);

    return followUpSummaries;
  } catch (error) {
    console.error("Error fetching follow up details:", error);
    throw error;
  }
};

// Get Site Visited Data By Count
export const GetSiteVisitedDataByCount = async (params: {
  userId: number;
  tenantId: number;
  leadIds?: number[];
  taskIds?: number[]; // ✅ added
}) => {
  try {
    const accessToken = localStorage.getItem("authToken");

    // ✅ LeadIds Query Params
    const leadIdParams =
      params.leadIds && params.leadIds.length > 0
        ? "&" + params.leadIds.map((id) => `leadId=${id}`).join("&")
        : "";

    // ✅ TaskIds Query Params
    const taskIdParams =
      params.taskIds && params.taskIds.length > 0
        ? "&" + params.taskIds.map((id) => `taskId=${id}`).join("&")
        : "";

    const response = await fetch(
      `${BASE_URL}/UserReport/GetSiteVisitedDataByCount?userid=${params.userId}&tenantId=${params.tenantId}${leadIdParams}${taskIdParams}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data.tasks || data.data || data;
  } catch (error) {
    console.error("Error fetching site visited data by count:", error);
    throw error;
  }
};

// Filter Site Visit Async
export const FilterSiteVisitAsync = async (filterParams: {
  tenantId: string | number;
  fromDate?: string;
  toDate?: string;
  userId?: number;       // selected from dropdown
  sourceId?: number;
  subSourceId?: number;
  inquireId?: number;
}) => {
  try {
    const accessToken      = localStorage.getItem("authToken");
    const loggedUserId     = Number(localStorage.getItem("UserId")     || "0");
    const userTypeId       = Number(localStorage.getItem("userTypeId") || "0");
    const isLoginAsManager = localStorage.getItem("isLoginAsManager") === "true";

    const ADMIN_USER_TYPE_ID = 1;

    const queryParams = new URLSearchParams();

    // ── Required ──────────────────────────────────────────────────────────────
    queryParams.append("tenantId",   filterParams.tenantId.toString());
    queryParams.append("userTypeId", userTypeId.toString());

    // ── Manager flag ──────────────────────────────────────────────────────────
    if (isLoginAsManager) {
      queryParams.append("isLoginAsManager", "true");
    }

    // ── UserId priority ───────────────────────────────────────────────────────
    // Case 1: A specific user was picked from the dropdown → send that userId
    // Case 2: No dropdown selection + non-admin → send logged-in userId
    // Case 3: Admin with no dropdown selection → omit userId (sees all)
    if (filterParams.userId && filterParams.userId > 0) {
      queryParams.append("userId", filterParams.userId.toString());
    } else if (userTypeId !== ADMIN_USER_TYPE_ID && loggedUserId > 0) {
      queryParams.append("userId", loggedUserId.toString());
    }

    // ── Optional filters ──────────────────────────────────────────────────────
    if (filterParams.fromDate)    queryParams.append("fromDate",    filterParams.fromDate);
    if (filterParams.toDate)      queryParams.append("toDate",      filterParams.toDate);
    if (filterParams.sourceId)    queryParams.append("sourceId",    filterParams.sourceId.toString());
    if (filterParams.subSourceId) queryParams.append("subSourceId", filterParams.subSourceId.toString());
    if (filterParams.inquireId)   queryParams.append("inquireId",   filterParams.inquireId.toString());

    const url = `${BASE_URL}/UserReport/FilterSiteVisitAsync?${queryParams.toString()}`;

    console.log("FilterSiteVisitAsync URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    const followUpSummaries: UserSiteVisitedSummary[] =
      data.followUpSummaries ||
      data.data ||
      data;

    return followUpSummaries;

  } catch (error) {
    console.error("Error filtering site visit:", error);
    throw error;
  }
};
export const sendEmailWithAttachments = async (formData: FormData) => {
  const url = `${BASE_URL}/EmailFormat/EmailSentCode`;
  const resp = await axios.put(url, formData, {
    headers: {
      // Let axios/browser set Content-Type with boundary automatically
      // if you set Content-Type manually you might break the boundary.
    },
  });
  return resp.data;
};

//***********************************************/
//**************Lead Capture Method****************/
//*********************************************/
export async function GetLeadCaptureMethod(leadId: number, tenantId: number) {
  try {
    const token = localStorage.getItem("authToken"); // adjust key if different
    const response = await fetch(`${BASE_URL}/LeadAction/LeadCaptureMethod`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        Accept: "*/*",
      },
      body: JSON.stringify({ leadId, tenantId }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Request failed: ${response.status} ${text}`);
    }

    const data = await response.json();
    return data; // expect array of LeadCaptureMethodResponseEntity
  } catch (err) {
    console.error("GetLeadCaptureMethod error:", err);
    throw err;
  }
}
//***********************************************/
//**************Lead Capture Method**************/
//*********************************************/

export const GetUSerActivityReportData = async (filters?: any) => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const queryParams = new URLSearchParams();

    queryParams.append("tenantId", filters?.tenantId || "1000");

    if (filters?.userId) queryParams.append("userId", filters.userId);
    if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
    if (filters?.toDate) queryParams.append("toDate", filters.toDate);
    if (filters?.sourceId) queryParams.append("sourceId", filters.sourceId);
    if (filters?.subSourceId) queryParams.append("subSourceId", filters.subSourceId);
    if (filters?.leadTypeId) queryParams.append("leadType", filters.leadTypeId);

    queryParams.append("userTypeID", localStorage.getItem("userTypeId") || "0");

    if (localStorage.getItem("isLoginAsManager") === "true") {
      queryParams.append("isLoginAsManager", "true");
    }

    const url = `${BASE_URL}/UserReport/UserActivityReport?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};


// export const GetUSerActivityReportData = async (params?: any) => {
//   try {
//     const accessToken = localStorage.getItem("authToken");
//     const tenantId = localStorage.getItem("tenantId") || "0";
//     const userTypeID = localStorage.getItem("userTypeId") || "0";
//     const userId = localStorage.getItem("UserId") || "0";
//     const isLoginAsManager =
//       localStorage.getItem("isLoginAsManager") === "true";

//     const queryParams = new URLSearchParams();

//     queryParams.append("tenantId", tenantId);
//     queryParams.append("userTypeID", userTypeID);

//     if (userTypeID !== "1") {
//       queryParams.append("userId", userId);
//     }

//     if (isLoginAsManager) {
//       queryParams.append("isLoginAsManager", "true");
//     }

//     // ✅ ADD FILTER PARAMS
//     if (params?.fromDate) queryParams.append("fromDate", params.fromDate);
//     if (params?.toDate) queryParams.append("toDate", params.toDate);
//     if (params?.sourceId) queryParams.append("sourceId", params.sourceId);
//     if (params?.subSourceId) queryParams.append("subSourceId", params.subSourceId);
//     if (params?.userId) queryParams.append("userId", params.userId);
//     if (params?.leadTypeId) queryParams.append("leadType", params.leadTypeId);

//     const url = `${BASE_URL}/UserReport/UserActivityReport?${queryParams.toString()}`;

//     console.log("Final API URL:", url);

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         "Content-Type": "application/json",
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Error fetching User Activity Report:", error);
//     return [];
//   }
// };
export const GetLeadsByIds = async (
  leadIds: number[]
): Promise<any[]> => {

  try {

    const accessToken = localStorage.getItem("authToken");

    if (!accessToken)
      throw new Error("Auth token missing");

    const response = await fetch(
      `${BASE_URL}/UserReport/GetLeadsByIds`,
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },

        body: JSON.stringify({
          leadIds: leadIds
        }),
      }
    );

    if (!response.ok) {

      const text = await response.text();

      throw new Error(`API failed: ${text}`);
    }

    return await response.json();

  } catch (error: any) {

    console.error(
      "Error fetching leads by IDs:",
      error
    );

    throw error;
  }
};
// APIService.ts
export const getUserNextFollowUpReport = async (params?: any) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId") || "0";
    const userTypeID = localStorage.getItem("userTypeId") || "0";
    const userId = localStorage.getItem("UserId") || "0";
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();
    queryParams.append("TenantId", tenantId);
    queryParams.append("UserTypeId", userTypeID);

    // If not admin, pass UserId
    if (userTypeID !== "1") {
      queryParams.append("UserId", userId);
    }

    // Manager login flag
    if (isLoginAsManager) {
      queryParams.append("IsLoginAsManager", "true");
    }

    // Additional filters
    if (params) {
      if (params.fromDate) queryParams.append("FromDate", params.fromDate);
      if (params.toDate) queryParams.append("ToDate", params.toDate);
      if (params.userId) queryParams.append("UserId", params.userId);
      if (params.sourceId)
        queryParams.append("SourceId", params.sourceId.toString());
      if (params.subSourceId)
        queryParams.append("SubSourceId", params.subSourceId.toString());
      if (params.inquireId) queryParams.append("InquireId", params.inquireId);
    }

    const url = `${BASE_URL}/LeadWiseReport/UserNextFollowUpReport?${queryParams.toString()}`;

    console.log("Next Follow-up Report URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching Next Follow-up Report:", error);
    return { userNextFollowUp: [] };
  }
};

export const getCompleteTaskReport = async (params?: any) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId") || "0";
    const userTypeID = localStorage.getItem("userTypeId") || "0";
    const userId = localStorage.getItem("UserId") || "0";
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();

    queryParams.append("TenantId", tenantId);
    queryParams.append("UserTypeId", userTypeID);

    // If not admin, pass UserId
    if (userTypeID !== "1") {
      queryParams.append("UserId", userId);
    }

    // Manager login flag
    if (isLoginAsManager) {
      queryParams.append("IsLoginAsManager", "true");
    }

    // Additional filters
    if (params) {
      if (params.fromDate) queryParams.append("FromDate", params.fromDate);
      if (params.toDate) queryParams.append("ToDate", params.toDate);
      if (params.userId) queryParams.append("UserId", params.userId);
      if (params.sourceId)
        queryParams.append("SourceId", params.sourceId.toString());
      if (params.subSourceId)
        queryParams.append("SubSourceId", params.subSourceId.toString());
      if (params.inquireId) queryParams.append("InquireId", params.inquireId);
    }

    const url = `${BASE_URL}/LeadWiseReport/UserCompleteTaskDetails?${queryParams.toString()}`;

    console.log("Complete Task Report URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching Complete Task Report:", error);
    return { userNextFollowUp: [] };
  }
};
export const fetchManagers = async (): Promise<User[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    // Validate required values
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      // `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}&UserTypeId=2`,
      `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Handle 401
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: ApiResponse = await response.json();

    // Adjust this if your API structure is different
    return data.users;

  } catch (error) {
    console.error("Error fetching managers:", error);
    return [];
  }
};

export const fetchUsers = async (): Promise<User[]> => {
  try {
    // Retrieve stored values from localStorage
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("UserId");
    // Validate required values
    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication or tenant information");
    }

    const response = await fetch(
      // `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}&UserTypeId=4&IsGetByManager=true`,
      `${BASE_URL}/User/GetAllUsers?TenantId=${tenantId}&UserId=${userId}&UserTypeId=4&IsGetByManager=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Handle 401
    if (handleAuthError(response.status)) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: ApiResponse = await response.json();

    // Adjust this if your API structure is different
    return data.users;

  } catch (error) {
    console.error("Error fetching managers:", error);
    return [];
  }
};

export const impersonateUser = async (targetUserId: number) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");

    if (!accessToken || !tenantId) {
      throw new Error("Missing authentication info");
    }

    // ✅ Save original admin session ONLY once
    if (!localStorage.getItem("originalSession")) {
      const originalSession = {
        authToken: localStorage.getItem("authToken"),
        userFullName: localStorage.getItem("userFullName"),
        UserId: localStorage.getItem("UserId"), // ADMIN ID
        userTypeId: localStorage.getItem("userTypeId"),
        tenantId: localStorage.getItem("tenantId"),
      };

      localStorage.setItem("originalSession", JSON.stringify(originalSession));
    }

    const response = await fetch(`${BASE_URL}/Login/Impersonate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        tenantId: Number(tenantId),
        userId: targetUserId,
      }),
    });

    if (!response.ok) {
      console.error(await response.text());
      return null;
    }

    const data = await response.json();

    // ✅ Overwrite session with impersonated user
    localStorage.setItem("authToken", data.token);
    localStorage.setItem("UserId", data.userId);
    localStorage.setItem("userFullName", data.userFullName);
    localStorage.setItem("userTypeId", data.userTypeId);
    localStorage.setItem("isImpersonating", "true");

    return data;
  } catch (error) {
    console.error("Impersonation error:", error);
    return null;
  }
};


export const restoreOriginalSession = (): boolean => {
  try {
    const raw = localStorage.getItem("originalSession");
    if (!raw) return false;

    const original = JSON.parse(raw);

    if (!original || typeof original !== "object") {
      console.error("Invalid original session data");
      return false;
    }

    // ✅ Restore only expected keys
    const allowedKeys = [
      "authToken",
      "userFullName",
      "UserId",
      "userTypeId",
      "tenantId",
    ];

    allowedKeys.forEach((key) => {
      if (original[key]) {
        localStorage.setItem(key, original[key]);
      }
    });

    // ✅ Clear impersonation flags
    localStorage.removeItem("originalSession");
    localStorage.removeItem("isImpersonating");

    return true;
  } catch (error) {
    console.error("Error restoring session:", error);
    return false;
  }
};

export const getLeadsByIds = async (leadIds: number[]) => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("Auth token missing");

    const response = await fetch(`${BASE_URL}/UserReport/GetLeadsByIds`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(leadIds),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`API failed: ${text}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching lead details:", error);
    throw error;
  }
};


export const GetLeadReportLog = async (
  params?: Record<string, any>
): Promise<any> => {

  const token = localStorage.getItem("authToken");

  const tenantId = localStorage.getItem("tenantId") ?? "0";
  const userId = localStorage.getItem("UserId") ?? "0";
  const userTypeId = localStorage.getItem("userTypeId") ?? "0";
  const isLoginAsManager =
    localStorage.getItem("isLoginAsManager") === "true";

  // Base query parameters
  const base: Record<string, string> = {
    tenantId: tenantId,
    userId: userId,
    userTypeId: userTypeId
  };

  // ✅ Add manager flag
  if (isLoginAsManager) {
    base["isLoginAsManager"] = "true";
  }

  // Merge additional params
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        base[k] = String(v);
      }
    });
  }

  console.log("[GetLeadReportLog] query params:", base);

  const qs = "?" + new URLSearchParams(base).toString();
  const url = `${BASE_URL}/LeadWiseReport/GetLeadReportLog${qs}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("[GetLeadReportLog] HTTP", response.status, response.statusText);
    console.error("[GetLeadReportLog] Body:", errorText);
    throw new Error(`GetLeadReportLog failed [${response.status}]: ${errorText}`);
  }

  return response.json();
};


export const GetAllCampaignService = async () => {
  const tenantId = localStorage.getItem("tenantId");
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${BASE_URL}/Campaign/GetAllCampaignService?tenantId=${tenantId}&isActive=true`,
    { headers: { Authorization: `Bearer ${token}` } });
  const data = await res.json();
  return data?.campaigns ?? data ?? [];
};

// ─── Add these functions to your existing APIService.ts file ────────────────


/** Fetch all active users for the current tenant */
export const GetAllUsersForImportService = async () => {
  const tenantId = localStorage.getItem("tenantId");
  const token = localStorage.getItem("authToken");
  const res = await fetch(
    `${BASE_URL}/User/GetAllUsers?tenantId=${tenantId}&isActive=true`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const data = await res.json();
  return data?.users ?? data?.data ?? data ?? [];
};
export interface RowResult {
  row: number;
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  /** "Success" | "Duplicate" | "Error" */
  status: "Success" | "Duplicate" | "Error";
  reason: string;
}

export interface ImportLeadResult {
  success: boolean;
  message: string;
  totalRows: number;
  imported: number;
  duplicates: number;   // leads skipped because mobile/email already exists
  skipped: number;
  errorCount: number;
  errors: string[];
  rowResults: RowResult[];  // per-row detail used for the downloadable report
}
/** Upload xlsx lead file */
export const UploadLeadFileService = async (
  file: File,
  assignedUserId: number,
  createdBy: number,
  tenantId: number
): Promise<ImportLeadResult> => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(
    `${BASE_URL}/ImportLead/bulbupload?assignedUserId=${assignedUserId}&createdBy=${createdBy}&tenantId=${tenantId}`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      // ⚠️  Do NOT set Content-Type — browser sets multipart boundary automatically
      body: formData,
    }
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message ?? `Server error ${res.status}`);
  }

  return await res.json() as ImportLeadResult;
};

/** Download the xlsx lead import template */
export const DownloadLeadTemplateService = async () => {
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${BASE_URL}/ImportLead/template`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to download template");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "LeadImportTemplate.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
};


// ✅ GET LEADS BY IDS

export interface CreateStatePayload {
  stateName: string;
  createdBy: number;
}

export interface CreateStateResponse {
  isCreated: boolean;
  message: string;
}

export const CreateStateService = async (
  payload: CreateStatePayload
): Promise<CreateStateResponse> => {
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${BASE_URL}/Location/CreateState`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return data;
};

// ─── Add this to your existing APIService.ts ────────────────────────────────

export interface CreateDistrictPayload {
  districtName: string;
  stateID: number;
  createdBy: number;
}

export interface CreateDistrictResponse {
  isCreated: boolean;
  message: string;
}

export const CreateDistrictService = async (
  payload: CreateDistrictPayload
): Promise<CreateDistrictResponse> => {
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${BASE_URL}/Location/CreateDistrict`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return data;
};

// ─── Add this to your existing APIService.ts ────────────────────────────────

export interface UpdateAccessPermissionPayload {
  permissionId: number;
  tenantId: number;
  isAccessible: boolean;
  modifiedBy: number;
  userTypeId: number;
}

export interface UpdateAccessPermissionResponse {
  isUpdated: boolean;
  message?: string;
}

export const UpdateAccessPermissionService = async (
  payload: UpdateAccessPermissionPayload
): Promise<UpdateAccessPermissionResponse> => {
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${BASE_URL}/AccessPermission/UpdateAccessPermission`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

  const data = await res.json();
  return { isUpdated: true, ...data };
};
export interface ReasonType {
  id: number;
  name: string;
}
export interface CreateReasonPayload {
  typeId: number;
  description: string;
  createdBy: number;
}
export const fetchReasonTypes = async () => {
  const token = localStorage.getItem("authToken");

  const response = await fetch(`${BASE_URL}/Reason/GetReasonTypes`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) throw new Error("Failed to fetch reason types");

  return response.json();
};

export const fetchReasons = async (tenantId: number) => {
  const token = localStorage.getItem("authToken");
  const response = await fetch(`${BASE_URL}/Reason/GetReasons/${tenantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) throw new Error("Failed to fetch reasons");
  return response.json();
};

export const CreateReasonService = async (payload: CreateReasonPayload) => {
  const token = localStorage.getItem("authToken");
  const tenantId = localStorage.getItem("tenantId");
  const userId = localStorage.getItem("UserId") ?? "0";

  const requestBody = {
    ...payload,
    tenantId: tenantId,
    createdBy: userId
  };

  const response = await fetch(`${BASE_URL}/Reason/Create`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) throw new Error("Failed to create reason");

  return response.json();
};
export const UpdateReasonService = async (payload: any) => {
  const token = localStorage.getItem("authToken");
  const tenantId = localStorage.getItem("tenantId");
  const userId = localStorage.getItem("UserId") ?? "0";

  const requestBody = {
    ...payload,
    tenantId: tenantId,
    modifiedBy: userId
  };

  const response = await fetch(`${BASE_URL}/Reason/Update`, {
    method: "PUT", // change to POST if your API uses POST
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) throw new Error("Failed to update reason");

  return response.json();
};
export interface CountryCodeDto {
  countryCode: number;
  countryName: string;
  dialCode: string;
  value: string;
  label: string;
  fullLabel: string;
}

export const GetCountryCodes = async (): Promise<CountryCodeDto[]> => {
  try {
    const accessToken = localStorage.getItem("authToken");

    const response = await fetch(
      `${BASE_URL}/MasterData/GetCountryCodes`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch");
    }

    const data = await response.json();
    return data.countryCodes;

  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};


export const getPreSalesSitevisitReport = async (params?: any) => {
  try {
    const accessToken = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId") || "0";
    const userTypeID = localStorage.getItem("userTypeId") || "0";
    const userId = localStorage.getItem("UserId") || "0";
    const isLoginAsManager =
      localStorage.getItem("isLoginAsManager") === "true";

    const queryParams = new URLSearchParams();
    queryParams.append("TenantId", tenantId);
    queryParams.append("UserTypeId", userTypeID);

    // If not admin, pass UserId
    if (userTypeID !== "1") {
      queryParams.append("UserId", userId);
    }

    // Manager login flag
    if (isLoginAsManager) {
      queryParams.append("IsLoginAsManager", "true");
    }

    // Additional filters
    if (params) {
      if (params.fromDate) queryParams.append("FromDate", params.fromDate);
      if (params.toDate) queryParams.append("ToDate", params.toDate);
      if (params.sourceId)
        queryParams.append("SourceId", params.sourceId.toString());
      if (params.subSourceId)
        queryParams.append("SubSourceId", params.subSourceId.toString());
      if (params.inquireId)
        queryParams.append("InquireId", params.inquireId);
      if (params.firstAssignedUserId)
        queryParams.append("FirstAssignedUserId", params.firstAssignedUserId.toString());
      if (params.currentAssignedUserId)
        queryParams.append("CurrentAssignedUserId", params.currentAssignedUserId.toString());
    }

    const url = `${BASE_URL}/LeadWiseReport/GetPreSalesSitevisitReport?${queryParams.toString()}`;

    console.log("Pre Sales Site Visit Report URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching Pre Sales Site Visit Report:", error);
    return { userNextFollowUp: [] };
  }
};